/*!
 *
 * Constructor.io JavaScript Client, version 2.77.1
 * (c) 2015-2026 Constructor.io
 * ---
 * Constructor Search uses artificial intelligence to provide AI-first search, browse, and recommendations results that increase conversions and revenue.
 * - https://constructor.io
 * - https://github.com/Constructor-io/constructorio-client-javascript
 * ---
 * Includes code from the 'browserify/events' library, licensed under the MIT License.
 * For full license details, see the library documentation.
 *
 */
'use strict';
(() => {
  var qt = ((r) =>
    typeof require < 'u'
      ? require
      : typeof Proxy < 'u'
        ? new Proxy(r, { get: (t, e) => (typeof require < 'u' ? require : t)[e] })
        : r)(function (r) {
    if (typeof require < 'u') return require.apply(this, arguments);
    throw Error('Dynamic require of "' + r + '" is not supported');
  });
  var Vi = (r, t) => () => (r && (t = r((r = 0))), t);
  var N = (r, t) => () => (t || r((t = { exports: {} }).exports, t), t.exports);
  var T,
    b = Vi(() => {
      T = { env: { BUNDLED: 'true' } };
    });
  var Z = N((vo, be) => {
    b();
    function Gi(r) {
      return r && r.__esModule ? r : { default: r };
    }
    ((be.exports = Gi), (be.exports.__esModule = !0), (be.exports.default = be.exports));
  });
  var $ = N((go, qe) => {
    b();
    function Hi(r, t) {
      if (!(r instanceof t)) throw new TypeError('Cannot call a class as a function');
    }
    ((qe.exports = Hi), (qe.exports.__esModule = !0), (qe.exports.default = qe.exports));
  });
  var ve = N((po, ce) => {
    b();
    function it(r) {
      '@babel/helpers - typeof';
      return (
        (ce.exports = it =
          typeof Symbol == 'function' && typeof Symbol.iterator == 'symbol'
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t && typeof Symbol == 'function' && t.constructor === Symbol && t !== Symbol.prototype
                  ? 'symbol'
                  : typeof t;
              }),
        (ce.exports.__esModule = !0),
        (ce.exports.default = ce.exports),
        it(r)
      );
    }
    ((ce.exports = it), (ce.exports.__esModule = !0), (ce.exports.default = ce.exports));
  });
  var St = N((wo, me) => {
    b();
    var mt = ve().default;
    function Qi(r, t) {
      if (mt(r) != 'object' || !r) return r;
      var e = r[Symbol.toPrimitive];
      if (e !== void 0) {
        var i = e.call(r, t || 'default');
        if (mt(i) != 'object') return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
      }
      return (t === 'string' ? String : Number)(r);
    }
    ((me.exports = Qi), (me.exports.__esModule = !0), (me.exports.default = me.exports));
  });
  var rt = N((bo, Se) => {
    b();
    var Wi = ve().default,
      Xi = St();
    function Yi(r) {
      var t = Xi(r, 'string');
      return Wi(t) == 'symbol' ? t : t + '';
    }
    ((Se.exports = Yi), (Se.exports.__esModule = !0), (Se.exports.default = Se.exports));
  });
  var ee = N((mo, Ee) => {
    b();
    var Zi = rt();
    function Et(r, t) {
      for (var e = 0; e < t.length; e++) {
        var i = t[e];
        ((i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          'value' in i && (i.writable = !0),
          Object.defineProperty(r, Zi(i.key), i));
      }
    }
    function $i(r, t, e) {
      return (t && Et(r.prototype, t), e && Et(r, e), Object.defineProperty(r, 'prototype', { writable: !1 }), r);
    }
    ((Ee.exports = $i), (Ee.exports.__esModule = !0), (Ee.exports.default = Ee.exports));
  });
  var At = N((Eo, nt) => {
    b();
    (function () {
      Object.assign ||
        Object.defineProperty(Object, 'assign', {
          enumerable: !1,
          configurable: !0,
          writable: !0,
          value: function (e) {
            'use strict';
            if (e == null) throw new TypeError('Cannot convert first argument to object');
            for (var i = Object(e), n = 1; n < arguments.length; n++) {
              var s = arguments[n];
              if (s != null) {
                s = Object(s);
                for (var o = Object.keys(Object(s)), c = 0, l = o.length; l > c; c++) {
                  var a = o[c],
                    u = Object.getOwnPropertyDescriptor(s, a);
                  u !== void 0 && u.enumerable && (i[a] = s[a]);
                }
              }
            }
            return i;
          },
        });
      function r(e) {
        let i;
        try {
          i = window[e];
          let n = '__storage_test__';
          return (i.setItem(n, n), i.removeItem(n), !0);
        } catch (n) {
          return (
            DOMException &&
            n instanceof DOMException &&
            (n.name === 'QuotaExceededError' ||
              n.name === 'QUOTA_EXCEEDED_ERR' ||
              n.name === 'NS_ERROR_DOM_QUOTA_REACHED' ||
              n.toString().indexOf('QUOTA_EXCEEDED_ERR') !== -1 ||
              n.toString().indexOf('QuotaExceededError') !== -1) &&
            i &&
            i.length !== 0
          );
        }
      }
      var t = function (e) {
        var i = {
          user_agent: null,
          persist: !0,
          cookie_name_client_id: 'ConstructorioID_client_id',
          cookie_name_session_id: 'ConstructorioID_session_id',
          cookie_name_session_data: 'ConstructorioID_session',
          cookie_domain: null,
          cookie_secure: null,
          cookie_samesite: null,
          cookie_days_to_live: 365,
          local_name_client_id: '_constructorio_search_client_id',
          local_name_session_id: '_constructorio_search_session_id',
          local_name_session_data: '_constructorio_search_session',
          on_node: typeof window > 'u',
          session_is_new: null,
          new_to_beacon: null,
          client_id_storage_location: 'cookie',
          session_id_storage_location: 'local',
        };
        if ((Object.assign(this, i, e), !this.client_id))
          if (!this.on_node && this.persist) {
            var n;
            (this.client_id_storage_location === 'cookie' &&
              ((n = this.get_cookie(this.cookie_name_client_id)),
              n && (this.delete_cookie(this.cookie_name_client_id), this.set_cookie(this.cookie_name_client_id, n))),
              this.client_id_storage_location === 'local' && (n = this.get_local_object(this.local_name_client_id)),
              (this.client_id = n || this.generate_client_id()));
          } else this.client_id = this.generate_client_id();
        (this.session_id ||
          (!this.on_node && this.persist ? (this.session_id = this.generate_session_id()) : (this.session_id = 1)),
          this.on_node ||
            (this.user_agent = this.user_agent || (window && window.navigator && window.navigator.userAgent)));
      };
      ((t.prototype.set_cookie = function (e, i) {
        if (!this.on_node && this.persist) {
          var n = new Date(Date.now() + this.cookie_days_to_live * 24 * 60 * 60 * 1e3),
            s = e + '=' + i + '; expires=' + n.toUTCString() + '; path=/';
          return (
            this.cookie_domain && (s += '; domain=' + this.cookie_domain),
            this.cookie_secure && (s += '; secure'),
            this.cookie_samesite && (s += '; samesite=' + this.cookie_samesite),
            (document.cookie = s),
            s
          );
        }
        return null;
      }),
        (t.prototype.get_cookie = function (e) {
          for (var i = e + '=', n = document.cookie.split(';'), s = 0; s < n.length; s++) {
            var o = n[s];
            try {
              for (var c = decodeURIComponent(o); c.charAt(0) === ' '; ) c = c.substring(1);
              if (c.indexOf(i) === 0) return c.substring(i.length, c.length);
            } catch {}
          }
        }),
        (t.prototype.delete_cookie = function (e) {
          document.cookie = e + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        }),
        (t.prototype.generate_client_id = function () {
          var e;
          if (!this.on_node) {
            var i = this.get_cookie(this.cookie_name_client_id),
              n = this.get_local_object(this.local_name_client_id);
            (this.client_id_storage_location === 'cookie' &&
              n &&
              ((e = n),
              this.set_cookie(this.cookie_name_client_id, e),
              this.delete_local_object(this.local_name_client_id)),
              this.client_id_storage_location === 'local' &&
                i &&
                ((e = i),
                this.set_local_object(this.local_name_client_id, e),
                this.delete_cookie(this.cookie_name_client_id)));
          }
          return (
            e ||
              ((e = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (s) {
                var o = (Math.random() * 16) | 0,
                  c = s === 'x' ? o : (o & 3) | 8;
                return c.toString(16);
              })),
              this.client_id_storage_location === 'cookie' && this.set_cookie(this.cookie_name_client_id, e),
              this.client_id_storage_location === 'local' && this.set_local_object(this.local_name_client_id, e)),
            e
          );
        }),
        (t.prototype.get_local_object = function (e) {
          var i,
            n = r('localStorage') && window && window.localStorage;
          if (n && typeof e == 'string')
            try {
              i = JSON.parse(n.getItem(e));
            } catch {
              i = n.getItem(e);
            }
          return i;
        }),
        (t.prototype.set_local_object = function (e, i) {
          var n = r('localStorage') && window && window.localStorage;
          if (n && typeof e == 'string') {
            if (typeof i == 'object')
              try {
                n.setItem(e, JSON.stringify(i));
              } catch {}
            if (typeof i == 'string' || typeof i == 'number')
              try {
                n.setItem(e, i);
              } catch {}
          }
        }),
        (t.prototype.delete_local_object = function (e) {
          var i = r('localStorage') && window && window.localStorage;
          if (i && typeof e == 'string')
            try {
              i.removeItem(e);
            } catch {}
        }),
        (t.prototype.generate_session_id = function () {
          var e = this.get_cookie(this.cookie_name_session_data),
            i = this.get_local_object(this.local_name_session_data),
            n = Date.now(),
            s = 1e3 * 60 * 30,
            o;
          if (
            (this.session_id_storage_location === 'local' &&
              ((o = this.get_local_object(this.local_name_session_data)),
              !o && e && ((o = e), this.delete_cookie(this.cookie_name_session_data))),
            this.session_id_storage_location === 'cookie')
          ) {
            o = this.get_cookie(this.cookie_name_session_data);
            try {
              o = JSON.parse(o);
            } catch {}
            !o && i && ((o = i), this.delete_local_object(this.local_name_session_data));
          }
          var c = 1,
            l = 1;
          (o &&
            typeof o == 'object' &&
            ((l = parseInt(o.sessionId, 10) || 1), o.lastTime > n - s ? (c = l) : (c = l + 1)),
            (this.session_id = c),
            (this.session_is_new = !(o && l === c)),
            o && o.newToBeacon && (this.new_to_beacon = !0));
          let a = { sessionId: c, lastTime: n };
          return (
            this.session_is_new && (a.newToBeacon = !0),
            this.session_id_storage_location === 'local' &&
              (this.set_local_object(this.local_name_session_id, c),
              this.set_local_object(this.local_name_session_data, a)),
            this.session_id_storage_location === 'cookie' &&
              (this.cookie_domain &&
                (this.delete_cookie(this.cookie_name_session_id), this.delete_cookie(this.cookie_name_session_data)),
              this.set_cookie(this.cookie_name_session_id, c),
              this.set_cookie(this.cookie_name_session_data, JSON.stringify(a))),
            c
          );
        }),
        typeof nt < 'u' && typeof qt < 'u' && (nt.exports = t));
    })();
  });
  var Ct = N((ot) => {
    b();
    var Rt;
    (function (r) {
      typeof DO_NOT_EXPORT_CRC > 'u'
        ? typeof ot == 'object'
          ? r(ot)
          : typeof define == 'function' && define.amd
            ? define(function () {
                var t = {};
                return (r(t), t);
              })
            : r((Rt = {}))
        : r((Rt = {}));
    })(function (r) {
      r.version = '1.2.2';
      function t() {
        for (var d = 0, R = new Array(256), g = 0; g != 256; ++g)
          ((d = g),
            (d = d & 1 ? -306674912 ^ (d >>> 1) : d >>> 1),
            (d = d & 1 ? -306674912 ^ (d >>> 1) : d >>> 1),
            (d = d & 1 ? -306674912 ^ (d >>> 1) : d >>> 1),
            (d = d & 1 ? -306674912 ^ (d >>> 1) : d >>> 1),
            (d = d & 1 ? -306674912 ^ (d >>> 1) : d >>> 1),
            (d = d & 1 ? -306674912 ^ (d >>> 1) : d >>> 1),
            (d = d & 1 ? -306674912 ^ (d >>> 1) : d >>> 1),
            (d = d & 1 ? -306674912 ^ (d >>> 1) : d >>> 1),
            (R[g] = d));
        return typeof Int32Array < 'u' ? new Int32Array(R) : R;
      }
      var e = t();
      function i(d) {
        var R = 0,
          g = 0,
          C = 0,
          U = typeof Int32Array < 'u' ? new Int32Array(4096) : new Array(4096);
        for (C = 0; C != 256; ++C) U[C] = d[C];
        for (C = 0; C != 256; ++C) for (g = d[C], R = 256 + C; R < 4096; R += 256) g = U[R] = (g >>> 8) ^ d[g & 255];
        var O = [];
        for (C = 1; C != 16; ++C)
          O[C - 1] = typeof Int32Array < 'u' ? U.subarray(C * 256, C * 256 + 256) : U.slice(C * 256, C * 256 + 256);
        return O;
      }
      var n = i(e),
        s = n[0],
        o = n[1],
        c = n[2],
        l = n[3],
        a = n[4],
        u = n[5],
        f = n[6],
        v = n[7],
        h = n[8],
        _ = n[9],
        p = n[10],
        y = n[11],
        m = n[12],
        w = n[13],
        k = n[14];
      function S(d, R) {
        for (var g = R ^ -1, C = 0, U = d.length; C < U; ) g = (g >>> 8) ^ e[(g ^ d.charCodeAt(C++)) & 255];
        return ~g;
      }
      function q(d, R) {
        for (var g = R ^ -1, C = d.length - 15, U = 0; U < C; )
          g =
            k[d[U++] ^ (g & 255)] ^
            w[d[U++] ^ ((g >> 8) & 255)] ^
            m[d[U++] ^ ((g >> 16) & 255)] ^
            y[d[U++] ^ (g >>> 24)] ^
            p[d[U++]] ^
            _[d[U++]] ^
            h[d[U++]] ^
            v[d[U++]] ^
            f[d[U++]] ^
            u[d[U++]] ^
            a[d[U++]] ^
            l[d[U++]] ^
            c[d[U++]] ^
            o[d[U++]] ^
            s[d[U++]] ^
            e[d[U++]];
        for (C += 15; U < C; ) g = (g >>> 8) ^ e[(g ^ d[U++]) & 255];
        return ~g;
      }
      function E(d, R) {
        for (var g = R ^ -1, C = 0, U = d.length, O = 0, B = 0; C < U; )
          ((O = d.charCodeAt(C++)),
            O < 128
              ? (g = (g >>> 8) ^ e[(g ^ O) & 255])
              : O < 2048
                ? ((g = (g >>> 8) ^ e[(g ^ (192 | ((O >> 6) & 31))) & 255]),
                  (g = (g >>> 8) ^ e[(g ^ (128 | (O & 63))) & 255]))
                : O >= 55296 && O < 57344
                  ? ((O = (O & 1023) + 64),
                    (B = d.charCodeAt(C++) & 1023),
                    (g = (g >>> 8) ^ e[(g ^ (240 | ((O >> 8) & 7))) & 255]),
                    (g = (g >>> 8) ^ e[(g ^ (128 | ((O >> 2) & 63))) & 255]),
                    (g = (g >>> 8) ^ e[(g ^ (128 | ((B >> 6) & 15) | ((O & 3) << 4))) & 255]),
                    (g = (g >>> 8) ^ e[(g ^ (128 | (B & 63))) & 255]))
                  : ((g = (g >>> 8) ^ e[(g ^ (224 | ((O >> 12) & 15))) & 255]),
                    (g = (g >>> 8) ^ e[(g ^ (128 | ((O >> 6) & 63))) & 255]),
                    (g = (g >>> 8) ^ e[(g ^ (128 | (O & 63))) & 255])));
        return ~g;
      }
      ((r.table = e), (r.bstr = S), (r.buf = q), (r.str = E));
    });
  });
  var ze = N((xo, Ot) => {
    'use strict';
    b();
    function oe(r) {
      var t;
      try {
        t = window[r];
        var e = '__storage_test__';
        return (t.setItem(e, e), t.removeItem(e), !0);
      } catch (i) {
        return (
          typeof DOMException < 'u' &&
          i instanceof DOMException &&
          (i.name === 'QuotaExceededError' ||
            i.name === 'QUOTA_EXCEEDED_ERR' ||
            i.name === 'NS_ERROR_DOM_QUOTA_REACHED' ||
            i.toString().indexOf('QUOTA_EXCEEDED_ERR') !== -1 ||
            i.toString().indexOf('QuotaExceededError') !== -1) &&
          t &&
          t.length !== 0
        );
      }
    }
    var er = {
        overflow: {},
        get: function (t) {
          var e = this.overflow[t];
          if (e) return e;
          if (!oe('sessionStorage')) return null;
          var i = sessionStorage.getItem(t);
          if (i)
            try {
              return JSON.parse(i);
            } catch {
              return i;
            }
          return null;
        },
        set: function (t, e) {
          try {
            sessionStorage.setItem(t, JSON.stringify(e));
          } catch {
            this.overflow[t] = e;
          }
        },
        remove: function (t) {
          var e;
          ((e = this.overflow) !== null && e !== void 0 && e[t] && delete this.overflow[t],
            oe('sessionStorage') && sessionStorage.removeItem(t));
        },
        key: function (t) {
          var e, i;
          if (!oe('sessionStorage')) {
            var n;
            return (n = Object.keys(this.overflow)) === null || n === void 0 ? void 0 : n[t];
          }
          var s = (e = sessionStorage) === null || e === void 0 ? void 0 : e.key(t),
            o = ((i = sessionStorage) === null || i === void 0 ? void 0 : i.length) || 0;
          if (t >= o) {
            var c,
              l = t - o;
            return (c = Object.keys(this.overflow)) === null || c === void 0 ? void 0 : c[l];
          }
          return s;
        },
        length: function () {
          var t = Object.keys(this.overflow).length;
          return oe('sessionStorage') ? sessionStorage.length + t : t;
        },
        clear: function () {
          ((this.overflow = {}), oe('sessionStorage') && sessionStorage.clear());
        },
      },
      tr = {
        overflow: {},
        get: function (t) {
          var e = this.overflow[t];
          if (e) return e;
          if (!oe('localStorage')) return null;
          var i = localStorage.getItem(t);
          if (i)
            try {
              return JSON.parse(i);
            } catch {
              return i;
            }
          return null;
        },
        set: function (t, e) {
          try {
            localStorage.setItem(t, JSON.stringify(e));
          } catch {
            this.overflow[t] = e;
          }
        },
        remove: function (t) {
          var e;
          ((e = this.overflow) !== null && e !== void 0 && e[t] && delete this.overflow[t],
            oe('localStorage') && localStorage.removeItem(t));
        },
        key: function (t) {
          var e, i;
          if (!oe('localStorage')) {
            var n;
            return (n = Object.keys(this.overflow)) === null || n === void 0 ? void 0 : n[t];
          }
          var s = (e = localStorage) === null || e === void 0 ? void 0 : e.key(t),
            o = ((i = localStorage) === null || i === void 0 ? void 0 : i.length) || 0;
          if (t >= o) {
            var c,
              l = t - o;
            return (c = Object.keys(this.overflow)) === null || c === void 0 ? void 0 : c[l];
          }
          return s;
        },
        length: function () {
          var t = Object.keys(this.overflow).length;
          return oe('localStorage') ? localStorage.length + t : t;
        },
        clear: function () {
          ((this.overflow = {}), oe('localStorage') && localStorage.clear());
        },
      },
      ir = { local: tr, session: er, canUseStorage: oe };
    Ot.exports = ir;
  });
  var te = N((To, Ut) => {
    'use strict';
    b();
    var rr = Z(),
      st = rr(ve()),
      xt = Ct(),
      ut = ze(),
      at = '_constructorio_purchase_order_ids',
      nr = [
        { pattern: /[\w\-+\\.]+@([\w-]+\.)+[\w-]{2,4}/, replaceWith: '<email_omitted>' },
        {
          pattern:
            /^(?:\+\d{11,12}|\+\d{1,3}\s\d{3}\s\d{3}\s\d{3,4}|\(\d{3}\)\d{7}|\(\d{3}\)\s\d{3}\s\d{4}|\(\d{3}\)\d{3}-\d{4}|\(\d{3}\)\s\d{3}-\d{4})$/,
          replaceWith: '<phone_omitted>',
        },
        {
          pattern:
            /^(?:4[0-9]{15}|(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\d{3})\d{11})$/,
          replaceWith: '<credit_omitted>',
        },
      ],
      or = 2e3,
      z = {
        trimNonBreakingSpaces: function (t) {
          return t.replace(/\s/g, ' ').trim();
        },
        encodeURIComponentRFC3986: function (t) {
          return encodeURIComponent(t).replace(/[!'()*]/g, function (e) {
            return '%'.concat(e.charCodeAt(0).toString(16).toUpperCase());
          });
        },
        cleanParams: function (t) {
          var e = {};
          return (
            Object.keys(t).forEach(function (i) {
              var n = t[i];
              typeof n == 'string' ? (e[i] = z.trimNonBreakingSpaces(n)) : (e[i] = n);
            }),
            e
          );
        },
        trimUrl: function (t) {
          var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : or,
            i = t.toString();
          if (i.length <= e) return i;
          var n = new URL(t.toString()),
            s = n.searchParams,
            o = Array.from(s.entries());
          if (o.length === 0) return z.truncateString(i, e);
          o.sort(function (l, a) {
            var u = l[0].length + l[1].length,
              f = a[0].length + a[1].length;
            return f - u;
          });
          for (var c = 0; c < o.length && !(i.length <= e); c += 1) (s.delete(o[c][0]), (i = n.toString()));
          return i.length > e ? z.truncateString(i, e) : i;
        },
        cleanAndValidateUrl: function (t) {
          var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0,
            i = null;
          try {
            var n;
            if ((n = t) !== null && n !== void 0 && n.startsWith('android-app')) {
              var s;
              t = (s = t) === null || s === void 0 ? void 0 : s.replace('android-app', 'https');
            }
            var o = new URL(t, e),
              c = new URL(z.trimUrl(o));
            i = c.toString();
          } catch {}
          return i;
        },
        throwHttpErrorFromResponse: function (t, e) {
          return e.json().then(function (i) {
            throw (
              (t.message = i.message),
              (t.status = e.status),
              (t.statusText = e.statusText),
              (t.url = e.url),
              (t.headers = e.headers),
              t
            );
          });
        },
        canUseDOM: function () {
          return !!(typeof window < 'u' && window.document && window.document.createElement);
        },
        addEventListener: function (t, e, i) {
          z.canUseDOM() && window.addEventListener(t, e, i);
        },
        removeEventListener: function (t, e, i) {
          z.canUseDOM() && window.removeEventListener(t, e, i);
        },
        getNavigator: function () {
          return z.canUseDOM() ? window.navigator : { userAgent: '', webdriver: !1 };
        },
        isNil: function (t) {
          return t == null;
        },
        getWindowLocation: function () {
          return z.canUseDOM() ? window.location : {};
        },
        getDocumentReferrer: function () {
          var t = null;
          try {
            z.canUseDOM() && (t = z.cleanAndValidateUrl(document.referrer));
          } catch {}
          return t;
        },
        getCanonicalUrl: function () {
          var t = null;
          try {
            if (z.canUseDOM()) {
              var e,
                i = (e = document) === null || e === void 0 ? void 0 : e.querySelector('link[rel="canonical"]'),
                n = i?.getAttribute('href');
              n && (t = z.cleanAndValidateUrl(n, document.location.href));
            }
          } catch {}
          return t;
        },
        dispatchEvent: function (t) {
          z.canUseDOM() && window.dispatchEvent(t);
        },
        createCustomEvent: function (t, e) {
          if (z.canUseDOM())
            try {
              return new window.CustomEvent(t, { detail: e });
            } catch {
              var i = document.createEvent('CustomEvent');
              return (i.initCustomEvent(t, !1, !1, e), i);
            }
          return null;
        },
        hasOrderIdRecord: function (t) {
          var e = t.orderId,
            i = t.apiKey,
            n = e;
          i && (n = ''.concat(i, '-').concat(e));
          var s = xt.str(n.toString()),
            o = ut.local.get(at);
          return (typeof o == 'string' && (o = JSON.parse(o)), o && o.includes(s) ? !0 : null);
        },
        addOrderIdRecord: function (t) {
          var e = t.orderId,
            i = t.apiKey,
            n = e;
          i && (n = ''.concat(i, '-').concat(e));
          var s = xt.str(n.toString()),
            o = ut.local.get(at);
          if ((typeof o == 'string' && (o = JSON.parse(o)), o)) {
            if (o.includes(s)) return;
            (o.length >= 10 && (o = o.slice(-9)), o.push(s));
          } else o = [s];
          ut.local.set(at, o);
        },
        applyNetworkTimeout: function () {
          var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
            e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
            i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null,
            n = t && t.networkParameters && t.networkParameters.timeout,
            s = e && e.timeout,
            o = s || n;
          typeof o == 'number' &&
            i &&
            setTimeout(function () {
              return i.abort();
            }, o);
        },
        stringify: function (t, e, i) {
          if (!t) return '';
          var n = [];
          return (
            Object.keys(t).forEach(function (s) {
              var o = t[s],
                c = z.encodeURIComponentRFC3986(s),
                l;
              if (o != null) {
                var a = e ? ''.concat(e, '%5B').concat(c, '%5D') : c;
                (Array.isArray(o)
                  ? (l = z.stringify(o, a, 'array'))
                  : (0, st.default)(o) === 'object'
                    ? (l = z.stringify(o, a, 'object'))
                    : i === 'object'
                      ? (l = ''.concat(a, '=').concat(z.encodeURIComponentRFC3986(o)))
                      : (l = ''.concat(e || c, '=').concat(z.encodeURIComponentRFC3986(o))),
                  n.push(l));
              }
            }),
            n.join('&')
          );
        },
        toSnakeCase: function (t) {
          return t.replace(/[A-Z]/g, function (e) {
            return '_'.concat(e.toLowerCase());
          });
        },
        toSnakeCaseKeys: function (t) {
          var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1,
            i = {};
          return (
            Object.keys(t).forEach(function (n) {
              var s = z.toSnakeCase(n);
              i[s] =
                e && (0, st.default)(t[n]) === 'object' && !Array.isArray(t[n]) ? z.toSnakeCaseKeys(t[n], e) : t[n];
            }),
            i
          );
        },
        containsPii: function (t, e) {
          var i = t.toLowerCase();
          return e.test(i);
        },
        obfuscatePiiRequest: function (t) {
          var e = t;
          try {
            var i,
              n,
              s = new URL(t),
              o = s == null || (i = s.pathname) === null || i === void 0 ? void 0 : i.split('/'),
              c =
                s == null || (n = s.search) === null || n === void 0 || (n = n.split('&')) === null || n === void 0
                  ? void 0
                  : n.map(function (l) {
                      var a;
                      return (a = l.split('=')) === null || a === void 0 ? void 0 : a[1];
                    });
            nr.forEach(function (l) {
              var a = l.pattern,
                u = l.replaceWith;
              (o.forEach(function (f) {
                var v = decodeURIComponent(f);
                z.containsPii(v, a) && (e = e.replaceAll(f, u));
              }),
                c.forEach(function (f) {
                  var v = decodeURIComponent(f);
                  z.containsPii(v, a) && (e = e.replaceAll(v, u));
                }));
            });
          } catch {}
          return e;
        },
        convertResponseToJson: function (t) {
          return t.ok
            ? t.json().catch(function () {
                return t.text().then(function (e) {
                  throw new Error(
                    'Server responded with an invalid JSON object. Response code: '
                      .concat(t.code, ', Response: ')
                      .concat(e),
                  );
                });
              })
            : z.throwHttpErrorFromResponse(new Error(), t);
        },
        addHTTPSToString: function (t) {
          if (typeof t != 'string') return null;
          var e = t.startsWith('https://'),
            i = t.startsWith('http://');
          if (!e && i) return t.replace('http', 'https');
          if (!i && !e) {
            var n = 'https://'.concat(t);
            return n;
          }
          return t;
        },
        truncateString: function (t, e) {
          return t.slice(0, e);
        },
        toValidTestCells: function (t) {
          if (!t || (0, st.default)(t) !== 'object' || Array.isArray(t)) return {};
          var e = {};
          return (
            Object.keys(t).forEach(function (i) {
              typeof t[i] == 'string' && t[i].trim() !== '' && (e[i] = t[i]);
            }),
            e
          );
        },
        getBehaviorUrl: function (t) {
          var e = new URL(t);
          return (e.hostname.startsWith('behavior') || (e.hostname = 'behavior.'.concat(e.hostname)), e);
        },
      };
    Ut.exports = z;
  });
  var de = N((No, It) => {
    'use strict';
    b();
    var Tt = Z(),
      sr = Tt($()),
      ur = Tt(ee()),
      Je = te(),
      ar = (function () {
        function r(t) {
          var e = this;
          ((0, sr.default)(this, r),
            (this.events = []),
            (this.enabled = !(t && t.enabled === !1)),
            (this.waitForBeacon = !(t && t.waitForBeacon === !1)),
            (this.active = this.enabled),
            this.waitForBeacon &&
              ((this.active = !1),
              Je.canUseDOM() &&
                (window.ConstructorioAutocomplete || window.ConstructorioBeacon || window.ConstructorioTracker) &&
                this.enabled &&
                ((this.active = !0), this.dispatchEvents()),
              Je.addEventListener('cio.beacon.loaded', function () {
                e.enabled && ((e.active = !0), e.dispatchEvents());
              })));
        }
        return (0, ur.default)(r, [
          {
            key: 'queue',
            value: function (e, i) {
              (this.events.push({ name: e, data: i }), this.active && this.dispatchEvents());
            },
          },
          {
            key: 'dispatchEvents',
            value: function () {
              for (; this.events.length; ) {
                var e = this.events.shift(),
                  i = e.name,
                  n = e.data,
                  s = 'cio.client.'.concat(i);
                Je.dispatchEvent(Je.createCustomEvent(s, n));
              }
            },
          },
        ]);
      })();
    It.exports = ar;
  });
  var Bt = N((Do, Dt) => {
    'use strict';
    b();
    var Lt = Z(),
      cr = Lt($()),
      lr = Lt(ee()),
      fr = de(),
      se = te();
    function Nt(r, t, e) {
      var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1,
        n = e.apiKey,
        s = e.version,
        o = e.serviceUrl,
        c = e.sessionId,
        l = e.clientId,
        a = e.userId,
        u = e.segments,
        f = e.testCells,
        v = { c: s };
      if (((v.key = n), (v.i = l), (v.s = c), !r || typeof r != 'string'))
        throw new Error('query is a required parameter of type string');
      if (
        (f &&
          Object.keys(f).forEach(function (B) {
            v['ef-'.concat(B)] = f[B];
          }),
        u && u.length && (v.us = u),
        a && (v.ui = String(a)),
        t)
      ) {
        var h = t.offset,
          _ = t.page,
          p = t.resultsPerPage,
          y = t.filters,
          m = t.sortBy,
          w = t.sortOrder,
          k = t.section,
          S = t.fmtOptions,
          q = t.hiddenFields,
          E = t.hiddenFacets,
          d = t.variationsMap,
          R = t.qsParam,
          g = t.preFilterExpression,
          C = t.filterMatchTypes;
        (se.isNil(h) || (v.offset = h),
          se.isNil(_) || (v.page = _),
          se.isNil(p) || (v.num_results_per_page = p),
          y && (v.filters = y),
          C && (v.filter_match_types = C),
          m && (v.sort_by = m),
          w && (v.sort_order = w),
          k && (v.section = k),
          S && (v.fmt_options = S),
          q && (v.fmt_options ? (v.fmt_options.hidden_fields = q) : (v.fmt_options = { hidden_fields: q })),
          E && (v.fmt_options ? (v.fmt_options.hidden_facets = E) : (v.fmt_options = { hidden_facets: E })),
          d && (v.variations_map = JSON.stringify(d)),
          g && (v.pre_filter_expression = JSON.stringify(g)),
          R && (v.qs = JSON.stringify(R)));
      }
      ((v._dt = Date.now()), (v = se.cleanParams(v)));
      var U = se.stringify(v),
        O = i ? 'search/natural_language' : 'search';
      return ''
        .concat(o, '/')
        .concat(O, '/')
        .concat(se.encodeURIComponentRFC3986(se.trimNonBreakingSpaces(r)), '?')
        .concat(U);
    }
    var vr = (function () {
      function r(t) {
        ((0, cr.default)(this, r), (this.options = t || {}), (this.eventDispatcher = new fr(t.eventDispatcher)));
      }
      return (0, lr.default)(r, [
        {
          key: 'getSearchResults',
          value: function (e, i) {
            var n = this,
              s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {},
              o,
              c = this.options.fetch,
              l;
            if (typeof AbortController == 'function') {
              var a = new AbortController();
              ((l = a && a.signal), se.applyNetworkTimeout(this.options, s, a));
            }
            try {
              o = Nt(e, i, this.options);
            } catch (u) {
              return Promise.reject(u);
            }
            return c(o, { signal: l })
              .then(se.convertResponseToJson)
              .then(function (u) {
                if (u.response && u.response.results)
                  return (
                    u.result_id &&
                      u.response.results.forEach(function (f) {
                        f.result_id = u.result_id;
                      }),
                    n.eventDispatcher.queue('search.getSearchResults.completed', u),
                    u
                  );
                if (u.response && u.response.redirect)
                  return (n.eventDispatcher.queue('search.getSearchResults.completed', u), u);
                throw new Error('getSearchResults response data is malformed');
              });
          },
        },
        {
          key: 'getVoiceSearchResults',
          value: function (e, i) {
            var n = this,
              s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {},
              o,
              c = this.options.fetch,
              l;
            if (typeof AbortController == 'function') {
              var a = new AbortController();
              ((l = a && a.signal), se.applyNetworkTimeout(this.options, s, a));
            }
            try {
              var u = !0;
              o = Nt(e, i, this.options, u);
            } catch (f) {
              return Promise.reject(f);
            }
            return c(o, { signal: l })
              .then(se.convertResponseToJson)
              .then(function (f) {
                if (f.response && f.response.results)
                  return (
                    f.result_id &&
                      f.response.results.forEach(function (v) {
                        v.result_id = f.result_id;
                      }),
                    n.eventDispatcher.queue('search.getVoiceSearchResults.completed', f),
                    f
                  );
                if (f.response && f.response.redirect)
                  return (n.eventDispatcher.queue('search.getVoiceSearchResults.completed', f), f);
                throw new Error('getVoiceSearchResults response data is malformed');
              });
          },
        },
      ]);
    })();
    Dt.exports = vr;
  });
  var Re = N((jo, Ae) => {
    b();
    var dr = rt();
    function hr(r, t, e) {
      return (
        (t = dr(t)) in r
          ? Object.defineProperty(r, t, { value: e, enumerable: !0, configurable: !0, writable: !0 })
          : (r[t] = e),
        r
      );
    }
    ((Ae.exports = hr), (Ae.exports.__esModule = !0), (Ae.exports.default = Ae.exports));
  });
  var Ft = N((Fo, Pt) => {
    'use strict';
    b();
    var ct = Z(),
      gr = ct($()),
      _r = ct(ee()),
      pr = ct(Re());
    function jt(r, t) {
      var e = Object.keys(r);
      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(r);
        (t &&
          (i = i.filter(function (n) {
            return Object.getOwnPropertyDescriptor(r, n).enumerable;
          })),
          e.push.apply(e, i));
      }
      return e;
    }
    function Ve(r) {
      for (var t = 1; t < arguments.length; t++) {
        var e = arguments[t] != null ? arguments[t] : {};
        t % 2
          ? jt(Object(e), !0).forEach(function (i) {
              (0, pr.default)(r, i, e[i]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(e))
            : jt(Object(e)).forEach(function (i) {
                Object.defineProperty(r, i, Object.getOwnPropertyDescriptor(e, i));
              });
      }
      return r;
    }
    var yr = de(),
      K = te();
    function Ce(r, t) {
      var e = t.apiKey,
        i = t.version,
        n = t.sessionId,
        s = t.clientId,
        o = t.userId,
        c = t.segments,
        l = t.testCells,
        a = { c: i };
      if (
        ((a.key = e),
        (a.i = s),
        (a.s = n),
        l &&
          Object.keys(l).forEach(function (R) {
            a['ef-'.concat(R)] = l[R];
          }),
        c && c.length && (a.us = c),
        o && (a.ui = String(o)),
        r)
      ) {
        var u = r.page,
          f = r.offset,
          v = r.resultsPerPage,
          h = r.filters,
          _ = r.sortBy,
          p = r.sortOrder,
          y = r.section,
          m = r.fmtOptions,
          w = r.hiddenFields,
          k = r.hiddenFacets,
          S = r.variationsMap,
          q = r.qsParam,
          E = r.preFilterExpression,
          d = r.filterMatchTypes;
        (K.isNil(u) || (a.page = u),
          K.isNil(f) || (a.offset = f),
          K.isNil(v) || (a.num_results_per_page = v),
          h && (a.filters = h),
          d && (a.filter_match_types = d),
          _ && (a.sort_by = _),
          p && (a.sort_order = p),
          y && (a.section = y),
          m && (a.fmt_options = m),
          w && (a.fmt_options ? (a.fmt_options.hidden_fields = w) : (a.fmt_options = { hidden_fields: w })),
          k && (a.fmt_options ? (a.fmt_options.hidden_facets = k) : (a.fmt_options = { hidden_facets: k })),
          S && (a.variations_map = JSON.stringify(S)),
          E && (a.pre_filter_expression = JSON.stringify(E)),
          q && (a.qs = JSON.stringify(q)));
      }
      return ((a._dt = Date.now()), (a = K.cleanParams(a)), a);
    }
    function wr(r, t, e, i) {
      var n = i.serviceUrl;
      if (!r || typeof r != 'string') throw new Error('filterName is a required parameter of type string');
      if (!t || typeof t != 'string') throw new Error('filterValue is a required parameter of type string');
      var s = Ce(e, i),
        o = K.stringify(s);
      return ''
        .concat(n, '/browse/')
        .concat(K.encodeURIComponentRFC3986(K.trimNonBreakingSpaces(r)), '/')
        .concat(K.encodeURIComponentRFC3986(K.trimNonBreakingSpaces(t)), '?')
        .concat(o);
    }
    function kr(r, t, e) {
      var i = e.serviceUrl;
      if (!r || !Array.isArray(r) || !r.length) throw new Error('ids is a required parameter of type array');
      var n = Ve(Ve({}, Ce(t, e)), {}, { ids: r }),
        s = K.stringify(n);
      return ''.concat(i, '/browse/items?').concat(s);
    }
    function br(r, t) {
      var e = t.serviceUrl,
        i = Ve({}, Ce(r, t));
      delete i._dt;
      var n = K.stringify(i);
      return ''.concat(e, '/browse/facets?').concat(n);
    }
    function qr(r, t, e) {
      var i = e.serviceUrl;
      if (!r || typeof r != 'string') throw new Error('facetName is a required parameter of type string');
      var n = Ve({}, Ce(t, e));
      ((n.facet_name = r), delete n._dt);
      var s = K.stringify(n);
      return ''.concat(i, '/browse/facet_options?').concat(s);
    }
    var mr = (function () {
      function r(t) {
        ((0, gr.default)(this, r), (this.options = t || {}), (this.eventDispatcher = new yr(t.eventDispatcher)));
      }
      return (0, _r.default)(r, [
        {
          key: 'getBrowseResults',
          value: function (e, i, n) {
            var s = this,
              o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {},
              c,
              l = this.options.fetch,
              a;
            if (typeof AbortController == 'function') {
              var u = new AbortController();
              ((a = u && u.signal), K.applyNetworkTimeout(this.options, o, u));
            }
            try {
              c = wr(e, i, n, this.options);
            } catch (f) {
              return Promise.reject(f);
            }
            return l(c, { signal: a })
              .then(K.convertResponseToJson)
              .then(function (f) {
                if (f.response && f.response.results)
                  return (
                    f.result_id &&
                      f.response.results.forEach(function (v) {
                        v.result_id = f.result_id;
                      }),
                    s.eventDispatcher.queue('browse.getBrowseResults.completed', f),
                    f
                  );
                throw new Error('getBrowseResults response data is malformed');
              });
          },
        },
        {
          key: 'getBrowseResultsForItemIds',
          value: function (e, i) {
            var n = this,
              s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {},
              o,
              c = this.options.fetch,
              l;
            if (typeof AbortController == 'function') {
              var a = new AbortController();
              ((l = a && a.signal), K.applyNetworkTimeout(this.options, s, a));
            }
            try {
              o = kr(e, i, this.options);
            } catch (u) {
              return Promise.reject(u);
            }
            return c(o, { signal: l })
              .then(K.convertResponseToJson)
              .then(function (u) {
                if (u.response && u.response.results)
                  return (
                    u.result_id &&
                      u.response.results.forEach(function (f) {
                        f.result_id = u.result_id;
                      }),
                    n.eventDispatcher.queue('browse.getBrowseResultsForItemIds.completed', u),
                    u
                  );
                throw new Error('getBrowseResultsForItemIds response data is malformed');
              });
          },
        },
        {
          key: 'getBrowseGroups',
          value: function (e) {
            var i = this,
              n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
              s = this.options.fetch,
              o = this.options.serviceUrl,
              c = Ce(e, this.options),
              l;
            if (typeof AbortController == 'function') {
              var a = new AbortController();
              ((l = a && a.signal), K.applyNetworkTimeout(this.options, n, a));
            }
            delete c._dt;
            var u = K.stringify(c),
              f = ''.concat(o, '/browse/groups?').concat(u);
            return s(f, { signal: l })
              .then(K.convertResponseToJson)
              .then(function (v) {
                if (v.response && v.response.groups)
                  return (i.eventDispatcher.queue('browse.getBrowseGroups.completed', v), v);
                throw new Error('getBrowseGroups response data is malformed');
              });
          },
        },
        {
          key: 'getBrowseFacets',
          value: function (e, i) {
            var n = this,
              s,
              o = this.options.fetch,
              c;
            if (typeof AbortController == 'function') {
              var l = new AbortController();
              ((c = l && l.signal), K.applyNetworkTimeout(this.options, i, l));
            }
            try {
              s = br(e, this.options);
            } catch (a) {
              return Promise.reject(a);
            }
            return o(s, { signal: c })
              .then(K.convertResponseToJson)
              .then(function (a) {
                if (a.response && a.response.facets)
                  return (n.eventDispatcher.queue('browse.getBrowseFacets.completed', a), a);
                throw new Error('getBrowseFacets response data is malformed');
              });
          },
        },
        {
          key: 'getBrowseFacetOptions',
          value: function (e) {
            var i = this,
              n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
              s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {},
              o,
              c = this.options.fetch,
              l;
            if (typeof AbortController == 'function') {
              var a = new AbortController();
              ((l = a && a.signal), K.applyNetworkTimeout(this.options, s, a));
            }
            try {
              o = qr(e, n, this.options);
            } catch (u) {
              return Promise.reject(u);
            }
            return c(o, { signal: l })
              .then(K.convertResponseToJson)
              .then(function (u) {
                if (u.response && u.response.facets)
                  return (i.eventDispatcher.queue('browse.getBrowseFacetOptions.completed', u), u);
                throw new Error('getBrowseFacetOptions response data is malformed');
              });
          },
        },
      ]);
    })();
    Pt.exports = mr;
  });
  var Jt = N((zo, zt) => {
    'use strict';
    b();
    var Mt = Z(),
      Sr = Mt($()),
      Er = Mt(ee()),
      Ar = de(),
      pe = te(),
      Rr = pe.convertResponseToJson,
      Cr = pe.cleanParams,
      Or = pe.applyNetworkTimeout,
      xr = pe.trimNonBreakingSpaces,
      Ur = pe.encodeURIComponentRFC3986,
      Tr = pe.stringify;
    function Ir(r, t, e) {
      var i = e.apiKey,
        n = e.version,
        s = e.serviceUrl,
        o = e.sessionId,
        c = e.clientId,
        l = e.userId,
        a = e.segments,
        u = e.testCells,
        f = { c: n };
      if (((f.key = i), (f.i = c), (f.s = o), !r || typeof r != 'string'))
        throw new Error('query is a required parameter of type string');
      if (
        (u &&
          Object.keys(u).forEach(function (d) {
            f['ef-'.concat(d)] = u[d];
          }),
        a && a.length && (f.us = a),
        l && (f.ui = String(l)),
        t)
      ) {
        var v = t.numResults,
          h = t.resultsPerSection,
          _ = t.filters,
          p = t.filtersPerSection,
          y = t.hiddenFields,
          m = t.variationsMap,
          w = t.preFilterExpression,
          k = t.qsParam,
          S = t.fmtOptions;
        (v && (f.num_results = v),
          h &&
            Object.keys(h).forEach(function (d) {
              f['num_results_'.concat(d)] = h[d];
            }),
          _ && (f.filters = _),
          p &&
            Object.keys(p).forEach(function (d) {
              f['filters['.concat(d, ']')] = p[d];
            }),
          w && (f.pre_filter_expression = JSON.stringify(w)),
          S && (f.fmt_options = S),
          y && (f.fmt_options ? (f.fmt_options.hidden_fields = y) : (f.fmt_options = { hidden_fields: y })),
          m && (f.variations_map = JSON.stringify(m)),
          k && (f.qs = JSON.stringify(k)));
      }
      ((f._dt = Date.now()), (f = Cr(f)));
      var q = Tr(f),
        E = r.replace(/^\//, '|');
      return ''
        .concat(s, '/autocomplete/')
        .concat(Ur(xr(E)), '?')
        .concat(q);
    }
    var Nr = (function () {
      function r(t) {
        ((0, Sr.default)(this, r), (this.options = t || {}), (this.eventDispatcher = new Ar(t.eventDispatcher)));
      }
      return (0, Er.default)(r, [
        {
          key: 'getAutocompleteResults',
          value: function (e, i) {
            var n = this,
              s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {},
              o,
              c = this.options.fetch,
              l;
            if (typeof AbortController == 'function') {
              var a = new AbortController();
              ((l = a && a.signal), Or(this.options, s, a));
            }
            try {
              o = Ir(e, i, this.options);
            } catch (u) {
              return Promise.reject(u);
            }
            return c(o, { signal: l })
              .then(Rr)
              .then(function (u) {
                if (u.sections) {
                  if (u.result_id) {
                    var f = Object.keys(u.sections);
                    f.forEach(function (v) {
                      var h = u.sections[v];
                      h.length &&
                        h.forEach(function (_) {
                          _.result_id = u.result_id;
                        });
                    });
                  }
                  return (n.eventDispatcher.queue('autocomplete.getAutocompleteResults.completed', u), u);
                }
                throw new Error('getAutocompleteResults response data is malformed');
              });
          },
        },
      ]);
    })();
    zt.exports = Nr;
  });
  var Gt = N((Vo, Kt) => {
    'use strict';
    b();
    var Vt = Z(),
      Lr = Vt($()),
      Dr = Vt(ee()),
      Br = de(),
      he = te();
    function jr(r, t, e) {
      var i = e.apiKey,
        n = e.version,
        s = e.serviceUrl,
        o = e.sessionId,
        c = e.userId,
        l = e.clientId,
        a = e.segments,
        u = { c: n };
      if (((u.key = i), (u.i = l), (u.s = o), !r || typeof r != 'string'))
        throw new Error('podId is a required parameter of type string');
      if ((a && a.length && (u.us = a), c && (u.ui = String(c)), t)) {
        var f = t.numResults,
          v = t.itemIds,
          h = t.variationId,
          _ = t.section,
          p = t.term,
          y = t.filters,
          m = t.variationsMap,
          w = t.hiddenFields,
          k = t.preFilterExpression,
          S = t.fmtOptions;
        if ((he.isNil(f) || (u.num_results = f), v && (u.item_id = v), h)) {
          if (!v || (typeof v == 'string' && !v.trim()))
            throw new Error('itemIds is a required parameter for variationId');
          if (Array.isArray(v) && !v.length)
            throw new Error('At least one itemId is a required parameter for variationId');
          u.variation_id = h;
        }
        (_ && (u.section = _),
          p && (u.term = p),
          y && (u.filters = y),
          S && (u.fmt_options = S),
          w && (u.fmt_options ? (u.fmt_options.hidden_fields = w) : (u.fmt_options = { hidden_fields: w })),
          m && (u.variations_map = JSON.stringify(m)),
          k && (u.pre_filter_expression = JSON.stringify(k)));
      }
      u = he.cleanParams(u);
      var q = he.stringify(u);
      return ''
        .concat(s, '/recommendations/v1/pods/')
        .concat(he.encodeURIComponentRFC3986(he.trimNonBreakingSpaces(r)), '?')
        .concat(q);
    }
    var Pr = (function () {
      function r(t) {
        ((0, Lr.default)(this, r), (this.options = t || {}), (this.eventDispatcher = new Br(t.eventDispatcher)));
      }
      return (0, Dr.default)(r, [
        {
          key: 'getRecommendations',
          value: function (e, i) {
            var n = this,
              s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {},
              o,
              c = this.options.fetch,
              l;
            if (typeof AbortController == 'function') {
              var a = new AbortController();
              ((l = a && a.signal), he.applyNetworkTimeout(this.options, s, a));
            }
            try {
              o = jr(e, i, this.options);
            } catch (u) {
              return Promise.reject(u);
            }
            return c(o, { signal: l })
              .then(he.convertResponseToJson)
              .then(function (u) {
                if (u.response && u.response.results)
                  return (
                    u.result_id &&
                      u.response.results.forEach(function (f) {
                        f.result_id = u.result_id;
                      }),
                    n.eventDispatcher.queue('recommendations.getRecommendations.completed', u),
                    u
                  );
                throw new Error('getRecommendations response data is malformed');
              });
          },
        },
      ]);
    })();
    Kt.exports = Pr;
  });
  var ri = N((Go, ft) => {
    'use strict';
    b();
    var Fr = Z(),
      lt = Fr(ve()),
      ye = (typeof Reflect > 'u' ? 'undefined' : (0, lt.default)(Reflect)) === 'object' ? Reflect : null,
      Ht =
        ye && typeof ye.apply == 'function'
          ? ye.apply
          : function (t, e, i) {
              return Function.prototype.apply.call(t, e, i);
            },
      Ke;
    ye && typeof ye.ownKeys == 'function'
      ? (Ke = ye.ownKeys)
      : Object.getOwnPropertySymbols
        ? (Ke = function (t) {
            return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
          })
        : (Ke = function (t) {
            return Object.getOwnPropertyNames(t);
          });
    function Mr(r) {
      console && console.warn && console.warn(r);
    }
    var Wt =
      Number.isNaN ||
      function (t) {
        return t !== t;
      };
    function F() {
      F.init.call(this);
    }
    ft.exports = F;
    ft.exports.once = Kr;
    F.EventEmitter = F;
    F.prototype._events = void 0;
    F.prototype._eventsCount = 0;
    F.prototype._maxListeners = void 0;
    var Qt = 10;
    function Ge(r) {
      if (typeof r != 'function')
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + (0, lt.default)(r));
    }
    Object.defineProperty(F, 'defaultMaxListeners', {
      enumerable: !0,
      get: function () {
        return Qt;
      },
      set: function (t) {
        if (typeof t != 'number' || t < 0 || Wt(t))
          throw new RangeError(
            'The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + '.',
          );
        Qt = t;
      },
    });
    F.init = function () {
      ((this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) &&
        ((this._events = Object.create(null)), (this._eventsCount = 0)),
        (this._maxListeners = this._maxListeners || void 0));
    };
    F.prototype.setMaxListeners = function (t) {
      if (typeof t != 'number' || t < 0 || Wt(t))
        throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + '.');
      return ((this._maxListeners = t), this);
    };
    function Xt(r) {
      return r._maxListeners === void 0 ? F.defaultMaxListeners : r._maxListeners;
    }
    F.prototype.getMaxListeners = function () {
      return Xt(this);
    };
    F.prototype.emit = function (t) {
      for (var e = [], i = 1; i < arguments.length; i++) e.push(arguments[i]);
      var n = t === 'error',
        s = this._events;
      if (s !== void 0) n = n && s.error === void 0;
      else if (!n) return !1;
      if (n) {
        var o;
        if ((e.length > 0 && (o = e[0]), o instanceof Error)) throw o;
        var c = new Error('Unhandled error.' + (o ? ' (' + o.message + ')' : ''));
        throw ((c.context = o), c);
      }
      var l = s[t];
      if (l === void 0) return !1;
      if (typeof l == 'function') Ht(l, this, e);
      else for (var a = l.length, u = ti(l, a), i = 0; i < a; ++i) Ht(u[i], this, e);
      return !0;
    };
    function Yt(r, t, e, i) {
      var n, s, o;
      if (
        (Ge(e),
        (s = r._events),
        s === void 0
          ? ((s = r._events = Object.create(null)), (r._eventsCount = 0))
          : (s.newListener !== void 0 && (r.emit('newListener', t, e.listener ? e.listener : e), (s = r._events)),
            (o = s[t])),
        o === void 0)
      )
        ((o = s[t] = e), ++r._eventsCount);
      else if (
        (typeof o == 'function' ? (o = s[t] = i ? [e, o] : [o, e]) : i ? o.unshift(e) : o.push(e),
        (n = Xt(r)),
        n > 0 && o.length > n && !o.warned)
      ) {
        o.warned = !0;
        var c = new Error(
          'Possible EventEmitter memory leak detected. ' +
            o.length +
            ' ' +
            String(t) +
            ' listeners added. Use emitter.setMaxListeners() to increase limit',
        );
        ((c.name = 'MaxListenersExceededWarning'), (c.emitter = r), (c.type = t), (c.count = o.length), Mr(c));
      }
      return r;
    }
    F.prototype.addListener = function (t, e) {
      return Yt(this, t, e, !1);
    };
    F.prototype.on = F.prototype.addListener;
    F.prototype.prependListener = function (t, e) {
      return Yt(this, t, e, !0);
    };
    function zr() {
      if (!this.fired)
        return (
          this.target.removeListener(this.type, this.wrapFn),
          (this.fired = !0),
          arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments)
        );
    }
    function Zt(r, t, e) {
      var i = { fired: !1, wrapFn: void 0, target: r, type: t, listener: e },
        n = zr.bind(i);
      return ((n.listener = e), (i.wrapFn = n), n);
    }
    F.prototype.once = function (t, e) {
      return (Ge(e), this.on(t, Zt(this, t, e)), this);
    };
    F.prototype.prependOnceListener = function (t, e) {
      return (Ge(e), this.prependListener(t, Zt(this, t, e)), this);
    };
    F.prototype.removeListener = function (t, e) {
      var i, n, s, o, c;
      if ((Ge(e), (n = this._events), n === void 0)) return this;
      if (((i = n[t]), i === void 0)) return this;
      if (i === e || i.listener === e)
        --this._eventsCount === 0
          ? (this._events = Object.create(null))
          : (delete n[t], n.removeListener && this.emit('removeListener', t, i.listener || e));
      else if (typeof i != 'function') {
        for (s = -1, o = i.length - 1; o >= 0; o--)
          if (i[o] === e || i[o].listener === e) {
            ((c = i[o].listener), (s = o));
            break;
          }
        if (s < 0) return this;
        (s === 0 ? i.shift() : Jr(i, s),
          i.length === 1 && (n[t] = i[0]),
          n.removeListener !== void 0 && this.emit('removeListener', t, c || e));
      }
      return this;
    };
    F.prototype.off = F.prototype.removeListener;
    F.prototype.removeAllListeners = function (t) {
      var e, i, n;
      if (((i = this._events), i === void 0)) return this;
      if (i.removeListener === void 0)
        return (
          arguments.length === 0
            ? ((this._events = Object.create(null)), (this._eventsCount = 0))
            : i[t] !== void 0 && (--this._eventsCount === 0 ? (this._events = Object.create(null)) : delete i[t]),
          this
        );
      if (arguments.length === 0) {
        var s = Object.keys(i),
          o;
        for (n = 0; n < s.length; ++n) ((o = s[n]), o !== 'removeListener' && this.removeAllListeners(o));
        return (
          this.removeAllListeners('removeListener'),
          (this._events = Object.create(null)),
          (this._eventsCount = 0),
          this
        );
      }
      if (((e = i[t]), typeof e == 'function')) this.removeListener(t, e);
      else if (e !== void 0) for (n = e.length - 1; n >= 0; n--) this.removeListener(t, e[n]);
      return this;
    };
    function $t(r, t, e) {
      var i = r._events;
      if (i === void 0) return [];
      var n = i[t];
      return n === void 0 ? [] : typeof n == 'function' ? (e ? [n.listener || n] : [n]) : e ? Vr(n) : ti(n, n.length);
    }
    F.prototype.listeners = function (t) {
      return $t(this, t, !0);
    };
    F.prototype.rawListeners = function (t) {
      return $t(this, t, !1);
    };
    F.listenerCount = function (r, t) {
      return typeof r.listenerCount == 'function' ? r.listenerCount(t) : ei.call(r, t);
    };
    F.prototype.listenerCount = ei;
    function ei(r) {
      var t = this._events;
      if (t !== void 0) {
        var e = t[r];
        if (typeof e == 'function') return 1;
        if (e !== void 0) return e.length;
      }
      return 0;
    }
    F.prototype.eventNames = function () {
      return this._eventsCount > 0 ? Ke(this._events) : [];
    };
    function ti(r, t) {
      for (var e = new Array(t), i = 0; i < t; ++i) e[i] = r[i];
      return e;
    }
    function Jr(r, t) {
      for (; t + 1 < r.length; t++) r[t] = r[t + 1];
      r.pop();
    }
    function Vr(r) {
      for (var t = new Array(r.length), e = 0; e < t.length; ++e) t[e] = r[e].listener || r[e];
      return t;
    }
    function Kr(r, t) {
      return new Promise(function (e, i) {
        function n(o) {
          (r.removeListener(t, s), i(o));
        }
        function s() {
          (typeof r.removeListener == 'function' && r.removeListener('error', n), e([].slice.call(arguments)));
        }
        (ii(r, t, s, { once: !0 }), t !== 'error' && Gr(r, n, { once: !0 }));
      });
    }
    function Gr(r, t, e) {
      typeof r.on == 'function' && ii(r, 'error', t, e);
    }
    function ii(r, t, e, i) {
      if (typeof r.on == 'function') i.once ? r.once(t, e) : r.on(t, e);
      else if (typeof r.addEventListener == 'function')
        r.addEventListener(t, function n(s) {
          (i.once && r.removeEventListener(t, n), e(s));
        });
      else
        throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + (0, lt.default)(r));
    }
  });
  var oi = N((Qo, ni) => {
    'use strict';
    b();
    ni.exports = [
      'Googlebot/',
      'Googlebot-Mobile',
      'Googlebot-Image',
      'Googlebot-News',
      'Googlebot-Video',
      'AdsBot-Google([^-]|$)',
      'AdsBot-Google-Mobile',
      'Feedfetcher-Google',
      'Mediapartners-Google',
      'Mediapartners \\(Googlebot\\)',
      'APIs-Google',
      'bingbot',
      'Slurp',
      '[wW]get',
      'curl',
      'LinkedInBot',
      'Python-urllib',
      'python-requests',
      'libwww',
      'httpunit',
      'nutch',
      'Go-http-client',
      'phpcrawl',
      'msnbot',
      'jyxobot',
      'FAST-WebCrawler',
      'FAST Enterprise Crawler',
      'BIGLOTRON',
      'Teoma',
      'convera',
      'seekbot',
      'Gigabot',
      'Gigablast',
      'exabot',
      'ia_archiver',
      'GingerCrawler',
      'webmon ',
      'HTTrack',
      'grub\\.org',
      'UsineNouvelleCrawler',
      'antibot',
      'netresearchserver',
      'speedy',
      'fluffy',
      'bibnum\\.bnf',
      'findlink',
      'msrbot',
      'panscient',
      'yacybot',
      'AISearchBot',
      'ips-agent',
      'tagoobot',
      'MJ12bot',
      'woriobot',
      'yanga',
      'buzzbot',
      'mlbot',
      'YandexBot',
      'yandex\\.com/bots',
      'purebot',
      'Linguee Bot',
      'CyberPatrol',
      'voilabot',
      'Baiduspider',
      'citeseerxbot',
      'spbot',
      'twengabot',
      'postrank',
      'turnitinbot',
      'scribdbot',
      'page2rss',
      'sitebot',
      'linkdex',
      'Adidxbot',
      'blekkobot',
      'ezooms',
      'dotbot',
      'Mail\\.RU_Bot',
      'discobot',
      'heritrix',
      'findthatfile',
      'europarchive\\.org',
      'NerdByNature\\.Bot',
      'sistrix crawler',
      'Ahrefs(Bot|SiteAudit)',
      'fuelbot',
      'CrunchBot',
      'centurybot9',
      'IndeedBot',
      'mappydata',
      'woobot',
      'ZoominfoBot',
      'PrivacyAwareBot',
      'Multiviewbot',
      'SWIMGBot',
      'Grobbot',
      'eright',
      'Apercite',
      'semanticbot',
      'Aboundex',
      'domaincrawler',
      'wbsearchbot',
      'summify',
      'CCBot',
      'edisterbot',
      'seznambot',
      'ec2linkfinder',
      'gslfbot',
      'aiHitBot',
      'intelium_bot',
      'facebookexternalhit',
      'Yeti',
      'RetrevoPageAnalyzer',
      'lb-spider',
      'Sogou',
      'lssbot',
      'careerbot',
      'wotbox',
      'wocbot',
      'ichiro',
      'DuckDuckBot',
      'lssrocketcrawler',
      'drupact',
      'webcompanycrawler',
      'acoonbot',
      'openindexspider',
      'gnam gnam spider',
      'web-archive-net\\.com\\.bot',
      'backlinkcrawler',
      'coccoc',
      'integromedb',
      'content crawler spider',
      'toplistbot',
      'it2media-domain-crawler',
      'ip-web-crawler\\.com',
      'siteexplorer\\.info',
      'elisabot',
      'proximic',
      'changedetection',
      'arabot',
      'WeSEE:Search',
      'niki-bot',
      'CrystalSemanticsBot',
      'rogerbot',
      '360Spider',
      'psbot',
      'InterfaxScanBot',
      'CC Metadata Scaper',
      'g00g1e\\.net',
      'GrapeshotCrawler',
      'urlappendbot',
      'brainobot',
      'fr-crawler',
      'binlar',
      'SimpleCrawler',
      'Twitterbot',
      'cXensebot',
      'smtbot',
      'bnf\\.fr_bot',
      'A6-Indexer',
      'ADmantX',
      'Facebot',
      'OrangeBot/',
      'memorybot',
      'AdvBot',
      'MegaIndex',
      'SemanticScholarBot',
      'ltx71',
      'nerdybot',
      'xovibot',
      'BUbiNG',
      'Qwantify',
      'archive\\.org_bot',
      'Applebot',
      'TweetmemeBot',
      'crawler4j',
      'findxbot',
      'S[eE][mM]rushBot',
      'yoozBot',
      'lipperhey',
      'Y!J',
      'Domain Re-Animator Bot',
      'AddThis',
      'Screaming Frog SEO Spider',
      'MetaURI',
      'Scrapy',
      'Livelap[bB]ot',
      'OpenHoseBot',
      'CapsuleChecker',
      'collection@infegy\\.com',
      'IstellaBot',
      'DeuSu/',
      'betaBot',
      'Cliqzbot/',
      'MojeekBot/',
      'netEstate NE Crawler',
      'SafeSearch microdata crawler',
      'Gluten Free Crawler/',
      'Sonic',
      'Sysomos',
      'Trove',
      'deadlinkchecker',
      'Slack-ImgProxy',
      'Embedly',
      'RankActiveLinkBot',
      'iskanie',
      'SafeDNSBot',
      'SkypeUriPreview',
      'Veoozbot',
      'Slackbot',
      'redditbot',
      'datagnionbot',
      'Google-Adwords-Instant',
      'adbeat_bot',
      'WhatsApp',
      'contxbot',
      'pinterest',
      'electricmonk',
      'GarlikCrawler',
      'BingPreview/',
      'vebidoobot',
      'FemtosearchBot',
      'Yahoo Link Preview',
      'MetaJobBot',
      'DomainStatsBot',
      'mindUpBot',
      'Daum/',
      'Jugendschutzprogramm-Crawler',
      'Xenu Link Sleuth',
      'Pcore-HTTP',
      'moatbot',
      'KosmioBot',
      'pingdom',
      'PhantomJS',
      'Gowikibot',
      'PiplBot',
      'Discordbot',
      'TelegramBot',
      'Jetslide',
      'newsharecounts',
      'James BOT',
      'Barkrowler',
      'TinEye',
      'SocialRankIOBot',
      'trendictionbot',
      'Ocarinabot',
      'epicbot',
      'Primalbot',
      'DuckDuckGo-Favicons-Bot',
      'GnowitNewsbot',
      'Leikibot',
      'LinkArchiver',
      'YaK/',
      'PaperLiBot',
      'Digg Deeper',
      'dcrawl',
      'Snacktory',
      'AndersPinkBot',
      'Fyrebot',
      'EveryoneSocialBot',
      'Mediatoolkitbot',
      'Luminator-robots',
      'ExtLinksBot',
      'SurveyBot',
      'NING/',
      'okhttp',
      'Nuzzel',
      'omgili',
      'PocketParser',
      'YisouSpider',
      'um-LN',
      'ToutiaoSpider',
      'MuckRack',
      "Jamie's Spider",
      'AHC/',
      'NetcraftSurveyAgent',
      'Laserlikebot',
      'Apache-HttpClient',
      'AppEngine-Google',
      'Jetty',
      'Upflow',
      'Thinklab',
      'Traackr\\.com',
      'Twurly',
      'Mastodon',
      'http_get',
      'DnyzBot',
      'botify',
      '007ac9 Crawler',
      'BehloolBot',
      'BrandVerity',
      'check_http',
      'BDCbot',
      'ZumBot',
      'EZID',
      'ICC-Crawler',
      'ArchiveBot',
      '^LCC ',
      'filterdb\\.iss\\.net/crawler',
      'BLP_bbot',
      'BomboraBot',
      'Buck/',
      'Companybook-Crawler',
      'Genieo',
      'magpie-crawler',
      'MeltwaterNews',
      'Moreover',
      'newspaper/',
      'ScoutJet',
      '(^| )sentry/',
      'StorygizeBot',
      'UptimeRobot',
      'OutclicksBot',
      'seoscanners',
      'Hatena',
      'Google Web Preview',
      'MauiBot',
      'AlphaBot',
      'SBL-BOT',
      'IAS crawler',
      'adscanner',
      'Netvibes',
      'acapbot',
      'Baidu-YunGuanCe',
      'bitlybot',
      'blogmuraBot',
      'Bot\\.AraTurka\\.com',
      'bot-pge\\.chlooe\\.com',
      'BoxcarBot',
      'BTWebClient',
      'ContextAd Bot',
      'Digincore bot',
      'Disqus',
      'Feedly',
      'Fetch/',
      'Fever',
      'Flamingo_SearchEngine',
      'FlipboardProxy',
      'g2reader-bot',
      'imrbot',
      'K7MLWCBot',
      'Kemvibot',
      'Landau-Media-Spider',
      'linkapediabot',
      'vkShare',
      'Siteimprove\\.com',
      'BLEXBot/',
      'DareBoost',
      'ZuperlistBot/',
      'Miniflux/',
      'Feedspotbot/',
      'Diffbot/',
      'SEOkicks',
      'tracemyfile',
      'Nimbostratus-Bot',
      'Bytespider',
      'BTTAgent',
      'OnCrawl',
    ];
  });
  var ci = N((Xo, ai) => {
    'use strict';
    b();
    var ui = Z(),
      Hr = ui($()),
      Qr = ui(ee()),
      vt = ze(),
      Wr = oi(),
      dt = te(),
      ht = '_constructorio_is_human',
      si = ['scroll', 'resize', 'touchmove', 'mouseover', 'mousemove', 'keydown', 'keypress', 'keyup', 'focus'],
      Xr = (function () {
        function r() {
          var t = this,
            e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          (0, Hr.default)(this, r);
          var i = e.humanityCheckLocation;
          ((this.store = i === 'local' ? vt.local : vt.session),
            (this.hasPerformedHumanEvent = this.getIsHumanFromStorage()));
          var n = function () {
            ((t.hasPerformedHumanEvent = !0),
              t.store.set(ht, !0),
              si.forEach(function (o) {
                dt.removeEventListener(o, n, !0);
              }));
          };
          this.hasPerformedHumanEvent ||
            si.forEach(function (s) {
              dt.addEventListener(s, n, !0);
            });
        }
        return (0, Qr.default)(r, [
          {
            key: 'getIsHumanFromStorage',
            value: function () {
              return !!this.store.get(ht) || !1;
            },
          },
          {
            key: 'getIsHumanFromSessionStorage',
            value: function () {
              return !!vt.session.get(ht) || !1;
            },
          },
          {
            key: 'isBot',
            value: function () {
              var e = dt.getNavigator(),
                i = e.userAgent,
                n = e.webdriver,
                s = new RegExp('('.concat(Wr.join('|'), ')'));
              return !!(i.match(s) || n || !this.getIsHumanFromStorage());
            },
          },
        ]);
      })();
    ai.exports = Xr;
  });
  var vi = N((Zo, fi) => {
    'use strict';
    b();
    var li = Z(),
      Yr = li($()),
      Zr = li(ee()),
      gt = ze(),
      $r = ci(),
      He = te(),
      en = te(),
      tn = en.obfuscatePiiRequest,
      _t = '_constructorio_requests',
      rn = 18e4,
      nn = (function () {
        function r(t, e) {
          var i = this;
          ((0, Yr.default)(this, r),
            (this.options = t),
            (this.eventemitter = e),
            (this.humanity = new $r(t)),
            (this.requestPending = !1),
            (this.pageUnloading = !1),
            (this.sendTrackingEvents = !!(t && t.sendTrackingEvents === !0)),
            He.addEventListener('visibilitychange', function () {
              document.visibilityState === 'hidden'
                ? (i.pageUnloading = !0)
                : document.visibilityState === 'visible' &&
                  i.pageUnloading === !0 &&
                  ((i.pageUnloading = !1), i.sendTrackingEvents && i.send());
            }),
            this.sendTrackingEvents && this.send());
        }
        return (0, Zr.default)(
          r,
          [
            {
              key: 'queue',
              value: function (e) {
                var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'GET',
                  n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {},
                  s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                if (this.sendTrackingEvents && (!He.canUseDOM() || !this.humanity.isBot())) {
                  var o = r.get(),
                    c = tn(e);
                  (o.push({ url: c, method: i, body: n, networkParameters: s }), r.set(o));
                }
              },
            },
            {
              key: 'sendEvents',
              value: function () {
                var e = this,
                  i = this.options.fetch,
                  n = r.get();
                if (
                  (!He.canUseDOM() || !this.humanity.isBot()) &&
                  !this.requestPending &&
                  !this.pageUnloading &&
                  n.length
                ) {
                  var s,
                    o = n.shift(),
                    c = o,
                    l = c.networkParameters,
                    a,
                    u = this;
                  if ((r.set(n), l && typeof AbortController == 'function')) {
                    var f = new AbortController();
                    ((a = f.signal), He.applyNetworkTimeout(this.options, l, f));
                  }
                  if ((typeof o == 'string' && (o = { url: o, method: 'GET' }), o.url)) {
                    var v = o.url.match(/\?.*_dt=([^&]+)/),
                      h = parseInt(v && v[1], 10),
                      _ = +new Date();
                    if (h && Number.isInteger(h) && _ - h > rn) {
                      ((this.sendTrackingEvents = !1), r.remove());
                      return;
                    }
                  }
                  (o.method === 'GET' && (s = i(o.url, { signal: a })),
                    o.method === 'POST' &&
                      (s = i(o.url, {
                        method: o.method,
                        body: JSON.stringify(o.body),
                        mode: 'cors',
                        headers: { 'Content-Type': 'text/plain' },
                        signal: a,
                      })),
                    s &&
                      ((this.requestPending = !0),
                      s
                        .then(function (p) {
                          p.ok
                            ? (u.eventemitter &&
                                u.eventemitter.emit('success', { url: o.url, method: o.method, message: 'ok' }),
                              (e.requestPending = !1),
                              e.send())
                            : p
                                .json()
                                .then(function (y) {
                                  (u.eventemitter &&
                                    u.eventemitter.emit('error', {
                                      url: o.url,
                                      method: o.method,
                                      message: y && y.message,
                                    }),
                                    (e.requestPending = !1),
                                    e.send());
                                })
                                .catch(function (y) {
                                  (u.eventemitter &&
                                    u.eventemitter.emit('error', { url: o.url, method: o.method, message: y.type }),
                                    (e.requestPending = !1),
                                    e.send());
                                });
                        })
                        .catch(function (p) {
                          (u.eventemitter &&
                            u.eventemitter.emit('error', {
                              url: o.url,
                              method: o.method,
                              message: p && p.toString && p.toString(),
                            }),
                            (e.requestPending = !1),
                            e.send());
                        })));
                }
              },
            },
            {
              key: 'send',
              value: function () {
                this.sendTrackingEvents &&
                  (this.options && this.options.trackingSendDelay === 0
                    ? this.sendEvents()
                    : setTimeout(this.sendEvents.bind(this), (this.options && this.options.trackingSendDelay) || 250));
              },
            },
          ],
          [
            {
              key: 'get',
              value: function () {
                return gt.local.get(_t) || [];
              },
            },
            {
              key: 'set',
              value: function (e) {
                !e || (Array.isArray(e) && e.length === 0) ? r.remove() : gt.local.set(_t, e);
                var i = r.get();
                Array.isArray(i) && i.length !== e.length && ((this.sendTrackingEvents = !1), r.remove());
              },
            },
            {
              key: 'remove',
              value: function () {
                gt.local.remove(_t);
              },
            },
          ],
        );
      })();
    fi.exports = nn;
  });
  var pi = N((es, _i) => {
    'use strict';
    b();
    var Qe = Z(),
      L = Qe(ve()),
      on = Qe(Re()),
      sn = Qe($()),
      un = Qe(ee());
    function di(r, t) {
      var e = Object.keys(r);
      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(r);
        (t &&
          (i = i.filter(function (n) {
            return Object.getOwnPropertyDescriptor(r, n).enumerable;
          })),
          e.push.apply(e, i));
      }
      return e;
    }
    function x(r) {
      for (var t = 1; t < arguments.length; t++) {
        var e = arguments[t] != null ? arguments[t] : {};
        t % 2
          ? di(Object(e), !0).forEach(function (i) {
              (0, on.default)(r, i, e[i]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(e))
            : di(Object(e)).forEach(function (i) {
                Object.defineProperty(r, i, Object.getOwnPropertyDescriptor(e, i));
              });
      }
      return r;
    }
    var an = ri(),
      A = te(),
      hi = vi(),
      Oe = 2048;
    function D(r, t) {
      var e = t.apiKey,
        i = t.version,
        n = t.sessionId,
        s = t.clientId,
        o = t.userId,
        c = t.segments,
        l = t.testCells,
        a = t.requestMethod,
        u = t.beaconMode,
        f = A.getWindowLocation(),
        v = f.host,
        h = f.pathname,
        _ = f.search,
        p = A.getCanonicalUrl(),
        y = A.getDocumentReferrer(),
        m = t.sendReferrerWithTrackingEvents !== !1,
        w = Object.assign(r);
      if (
        (i && (w.c = i),
        s && (w.i = s),
        n && (w.s = n),
        o && (w.ui = String(o)),
        c && c.length && (w.us = c),
        e && (w.key = e),
        y && (w.document_referrer = y),
        p && (w.canonical_url = p),
        l &&
          Object.keys(l).forEach(function (q) {
            w['ef-'.concat(q)] = l[q];
          }),
        u && a && a.match(/POST/i) && (w.beacon = !0),
        m && v && ((w.origin_referrer = v), h && (w.origin_referrer += h), _))
      )
        try {
          var k = [],
            S = new URLSearchParams(_);
          (S.forEach(function (q, E) {
            E.match(/utm_/) && k.push(''.concat(E, '=').concat(q));
          }),
            k.length && (w.origin_referrer += '?'.concat(k.join('&'))));
        } catch {}
      return ((w._dt = Date.now()), (w = A.cleanParams(w)), w);
    }
    function I(r, t) {
      return A.stringify(D(r, t));
    }
    var gi = (function () {
      function r(t) {
        ((0, sn.default)(this, r),
          (this.options = t || {}),
          (this.eventemitter = new an()),
          (this.requests = new hi(t, this.eventemitter)));
      }
      return (0, un.default)(r, [
        {
          key: 'trackSessionStartV2',
          value: function () {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
              i = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/session_start?');
            return (
              this.requests.queue(''.concat(i).concat(I({}, this.options)), 'POST', void 0, e),
              this.requests.send(),
              !0
            );
          },
        },
        {
          key: 'trackSessionStart',
          value: function () {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
              i = ''.concat(this.options.serviceUrl, '/behavior?'),
              n = { action: 'session_start' };
            return (
              this.requests.queue(''.concat(i).concat(I(n, this.options)), void 0, void 0, e),
              this.requests.send(),
              !0
            );
          },
        },
        {
          key: 'trackInputFocusV2',
          value: function () {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '',
              i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
              n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {},
              s = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/focus?'),
              o = {},
              c = i.analyticsTags,
              l = c === void 0 ? null : c;
            (l && (o.analytics_tags = l), (o.user_input = e));
            var a = 'POST',
              u = D(o, x(x({}, this.options), {}, { requestMethod: a }));
            return (this.requests.queue(''.concat(s).concat(I({}, this.options)), a, u, n), this.requests.send(), !0);
          },
        },
        {
          key: 'trackInputFocus',
          value: function () {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
              i = ''.concat(this.options.serviceUrl, '/behavior?'),
              n = { action: 'focus' };
            return (
              this.requests.queue(''.concat(i).concat(I(n, this.options)), void 0, void 0, e),
              this.requests.send(),
              !0
            );
          },
        },
        {
          key: 'trackItemDetailLoad',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/item_detail_load?'),
                s = {},
                o = {},
                c = e.item_name,
                l = e.name,
                a = e.item_id,
                u = e.customer_id,
                f = e.customerId,
                v = f === void 0 ? u : f,
                h = e.variation_id,
                _ = e.itemName,
                p = _ === void 0 ? c || l : _,
                y = e.itemId,
                m = y === void 0 ? a || v : y,
                w = e.variationId,
                k = w === void 0 ? h : w,
                S = e.url,
                q = e.analyticsTags;
              (p && (o.item_name = p),
                m && (o.item_id = m),
                k && (o.variation_id = k),
                q && (o.analytics_tags = q),
                S && (o.url = A.truncateString(S, Oe)));
              var E = ''.concat(n).concat(I(s, this.options)),
                d = 'POST',
                R = D(o, x(x({}, this.options), {}, { requestMethod: d }));
              return (this.requests.queue(E, d, R, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters are required of type object'));
          },
        },
        {
          key: 'trackAutocompleteSelectV2',
          value: function (e, i) {
            var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            if (e && typeof e == 'string') {
              if (i && (0, L.default)(i) === 'object' && !Array.isArray(i)) {
                var s = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/autocomplete_select?'),
                  o = i.original_query,
                  c = i.originalQuery,
                  l = c === void 0 ? o : c,
                  a = i.user_input,
                  u = i.userInput,
                  f = u === void 0 ? l || a : u,
                  v = i.original_section,
                  h = i.section,
                  _ = h === void 0 ? v : h,
                  p = i.tr,
                  y = i.group_id,
                  m = i.groupId,
                  w = m === void 0 ? y : m,
                  k = i.item_id,
                  S = i.itemId,
                  q = S === void 0 ? k : S,
                  E = i.variation_id,
                  d = i.variationId,
                  R = d === void 0 ? E : d,
                  g = i.slCampaignId,
                  C = i.slCampaignOwner,
                  U = {},
                  O = { user_input: f, tr: p, group_id: w, item_id: q, variation_id: R, item_name: e, section: _ };
                (_ && (U.section = _), g && (O.sl_campaign_id = g), C && (O.sl_campaign_owner = C));
                var B = ''.concat(s).concat(I(U, this.options)),
                  M = 'POST',
                  P = D(O, x(x({}, this.options), {}, { requestMethod: M }));
                return (this.requests.queue(B, M, P, n), this.requests.send(), !0);
              }
              return (this.requests.send(), new Error('parameters are required of type object'));
            }
            return (this.requests.send(), new Error('term is a required parameter of type string'));
          },
        },
        {
          key: 'trackAutocompleteSelect',
          value: function (e, i) {
            var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            if (e && typeof e == 'string') {
              if (i && (0, L.default)(i) === 'object' && !Array.isArray(i)) {
                var s = ''
                    .concat(this.options.serviceUrl, '/autocomplete/')
                    .concat(A.encodeURIComponentRFC3986(A.trimNonBreakingSpaces(e)), '/select?'),
                  o = {},
                  c = i.original_query,
                  l = i.originalQuery,
                  a = l === void 0 ? c : l,
                  u = i.section,
                  f = i.original_section,
                  v = i.originalSection,
                  h = v === void 0 ? f : v,
                  _ = i.tr,
                  p = i.group_id,
                  y = i.groupId,
                  m = y === void 0 ? p : y,
                  w = i.display_name,
                  k = i.displayName,
                  S = k === void 0 ? w : k,
                  q = i.item_id,
                  E = i.itemId,
                  d = E === void 0 ? q : E,
                  R = i.slCampaignOwner,
                  g = i.slCampaignId;
                return (
                  a && (o.original_query = a),
                  _ && (o.tr = _),
                  (h || u) && (o.section = h || u),
                  m && (o.group = { group_id: m, display_name: S }),
                  d && (o.item_id = d),
                  g && (o.sl_campaign_id = g),
                  R && (o.sl_campaign_owner = R),
                  this.requests.queue(''.concat(s).concat(I(o, this.options)), void 0, void 0, n),
                  this.requests.send(),
                  !0
                );
              }
              return (this.requests.send(), new Error('parameters are required of type object'));
            }
            return (this.requests.send(), new Error('term is a required parameter of type string'));
          },
        },
        {
          key: 'trackSearchSubmitV2',
          value: function (e, i) {
            var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            if (e && typeof e == 'string') {
              if (i && (0, L.default)(i) === 'object' && !Array.isArray(i)) {
                var s = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/search_submit?'),
                  o = i.original_query,
                  c = i.originalQuery,
                  l = c === void 0 ? o : c,
                  a = i.user_input,
                  u = i.userInput,
                  f = u === void 0 ? l || a : u,
                  v = i.group_id,
                  h = i.groupId,
                  _ = h === void 0 ? v : h,
                  p = i.section,
                  y = i.analyticsTags,
                  m = y === void 0 ? null : y,
                  w = {},
                  k = { user_input: f, search_term: e, section: p };
                (_ && (k.filters = { group_id: _ }), p && (w.section = p), m && (k.analytics_tags = m));
                var S = ''.concat(s).concat(I(w, this.options)),
                  q = 'POST',
                  E = D(k, x(x({}, this.options), {}, { requestMethod: q }));
                return (this.requests.queue(S, q, E, n), this.requests.send(), !0);
              }
              return (this.requests.send(), new Error('parameters are required of type object'));
            }
            return (this.requests.send(), new Error('term is a required parameter of type string'));
          },
        },
        {
          key: 'trackSearchSubmit',
          value: function (e, i) {
            var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            if (e && typeof e == 'string') {
              if (i && (0, L.default)(i) === 'object' && !Array.isArray(i)) {
                var s = ''
                    .concat(this.options.serviceUrl, '/autocomplete/')
                    .concat(A.encodeURIComponentRFC3986(A.trimNonBreakingSpaces(e)), '/search?'),
                  o = {},
                  c = i.original_query,
                  l = i.originalQuery,
                  a = l === void 0 ? c : l,
                  u = i.group_id,
                  f = i.groupId,
                  v = f === void 0 ? u : f,
                  h = i.display_name,
                  _ = i.displayName,
                  p = _ === void 0 ? h : _,
                  y = i.analyticsTags;
                return (
                  a && (o.original_query = a),
                  v && (o.group = { group_id: v, display_name: p }),
                  y && (o.analytics_tags = y),
                  this.requests.queue(''.concat(s).concat(I(o, this.options)), void 0, void 0, n),
                  this.requests.send(),
                  !0
                );
              }
              return (this.requests.send(), new Error('parameters are required of type object'));
            }
            return (this.requests.send(), new Error('term is a required parameter of type string'));
          },
        },
        {
          key: 'trackSearchResultsLoaded',
          value: function (e, i) {
            var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            if (e && typeof e == 'string') {
              if (i && (0, L.default)(i) === 'object' && !Array.isArray(i)) {
                var s,
                  o,
                  c,
                  l = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/search_result_load?'),
                  a = i.num_results,
                  u = i.numResults,
                  f = u === void 0 ? a : u,
                  v = i.result_count,
                  h = i.customerIds,
                  _ = i.customer_ids,
                  p = _ === void 0 ? h : _,
                  y = i.itemIds,
                  m = i.item_ids,
                  w = m === void 0 ? y : m,
                  k = i.items,
                  S = k === void 0 ? p || w : k,
                  q = i.result_page,
                  E = i.resultPage,
                  d = E === void 0 ? q : E,
                  R = i.result_id,
                  g = i.resultId,
                  C = g === void 0 ? R : g,
                  U = i.sort_order,
                  O = i.sortOrder,
                  B = O === void 0 ? U : O,
                  M = i.sort_by,
                  P = i.sortBy,
                  J = P === void 0 ? M : P,
                  Q = i.selected_filters,
                  j = i.selectedFilters,
                  X = j === void 0 ? Q : j,
                  H = i.url,
                  W =
                    H === void 0
                      ? ((s = A.getWindowLocation()) === null || s === void 0 ? void 0 : s.href) || 'N/A'
                      : H,
                  Y = i.section,
                  V = i.analyticsTags,
                  re = i.resultCount,
                  G =
                    re === void 0
                      ? (o = (c = f ?? v) !== null && c !== void 0 ? c : S?.length) !== null && o !== void 0
                        ? o
                        : 0
                      : re,
                  ue = {},
                  ne;
                if (S && Array.isArray(S) && S.length !== 0) {
                  var ae = S.slice(0, 100);
                  typeof S[0] == 'string' || typeof S[0] == 'number'
                    ? (ne = ae.map(function (_e) {
                        return { item_id: String(_e) };
                      }))
                    : (ne = ae.map(function (_e) {
                        return A.toSnakeCaseKeys(_e, !1);
                      }));
                }
                Y && (ue.section = Y);
                var Fe = {
                    search_term: e,
                    result_count: G,
                    items: ne,
                    result_page: d,
                    result_id: C,
                    sort_order: B,
                    sort_by: J,
                    selected_filters: X,
                    url: A.truncateString(W, Oe),
                    section: Y,
                    analytics_tags: V,
                  },
                  Me = ''.concat(l).concat(I(ue, this.options)),
                  ke = 'POST',
                  tt = D(Fe, x(x({}, this.options), {}, { requestMethod: ke }));
                return (this.requests.queue(Me, ke, tt, n), this.requests.send(), !0);
              }
              return (this.requests.send(), new Error('parameters are required of type object'));
            }
            return (this.requests.send(), new Error('term is a required parameter of type string'));
          },
        },
        {
          key: 'trackSearchResultClickV2',
          value: function (e, i) {
            var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            if (e && typeof e == 'string') {
              if (i && (0, L.default)(i) === 'object' && !Array.isArray(i)) {
                var s = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/search_result_click?'),
                  o = i.num_results,
                  c = i.customer_id,
                  l = i.item_id,
                  a = i.itemId,
                  u = a === void 0 ? c || l : a,
                  f = i.name,
                  v = i.item_name,
                  h = i.itemName,
                  _ = h === void 0 ? f || v : h,
                  p = i.variation_id,
                  y = i.variationId,
                  m = y === void 0 ? p : y,
                  w = i.result_id,
                  k = i.resultId,
                  S = k === void 0 ? w : k,
                  q = i.result_count,
                  E = i.resultCount,
                  d = E === void 0 ? o || q : E,
                  R = i.result_page,
                  g = i.resultPage,
                  C = g === void 0 ? R : g,
                  U = i.result_position_on_page,
                  O = i.resultPositionOnPage,
                  B = O === void 0 ? U : O,
                  M = i.num_results_per_page,
                  P = i.numResultsPerPage,
                  J = P === void 0 ? M : P,
                  Q = i.selected_filters,
                  j = i.selectedFilters,
                  X = j === void 0 ? Q : j,
                  H = i.section,
                  W = i.analyticsTags,
                  Y = i.slCampaignId,
                  V = i.slCampaignOwner,
                  re = {
                    sl_campaign_id: Y,
                    sl_campaign_owner: V,
                    item_name: _,
                    item_id: u,
                    variation_id: m,
                    result_id: S,
                    result_count: d,
                    result_page: C,
                    result_position_on_page: B,
                    num_results_per_page: J,
                    selected_filters: X,
                    section: H,
                    search_term: e,
                    analytics_tags: W,
                  },
                  G = {};
                H && (G.section = H);
                var ue = ''.concat(s).concat(I(G, this.options)),
                  ne = 'POST',
                  ae = D(re, x(x({}, this.options), {}, { requestMethod: ne }));
                return (this.requests.queue(ue, ne, ae, n), this.requests.send(), !0);
              }
              return (this.requests.send(), new Error('parameters are required of type object'));
            }
            return (this.requests.send(), new Error('term is a required parameter of type string'));
          },
        },
        {
          key: 'trackSearchResultClick',
          value: function (e, i) {
            var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            if (e && typeof e == 'string') {
              if (i && (0, L.default)(i) === 'object' && !Array.isArray(i)) {
                var s = ''
                    .concat(this.options.serviceUrl, '/autocomplete/')
                    .concat(A.encodeURIComponentRFC3986(A.trimNonBreakingSpaces(e)), '/click_through?'),
                  o = {},
                  c = i.item_name,
                  l = i.name,
                  a = i.itemName,
                  u = a === void 0 ? c || l : a,
                  f = i.item_id,
                  v = i.itemId,
                  h = v === void 0 ? f : v,
                  _ = i.customer_id,
                  p = i.customerId,
                  y = p === void 0 ? _ || h : p,
                  m = i.variation_id,
                  w = i.variationId,
                  k = w === void 0 ? m : w,
                  S = i.result_id,
                  q = i.resultId,
                  E = q === void 0 ? S : q,
                  d = i.item_is_convertible,
                  R = i.itemIsConvertible,
                  g = R === void 0 ? d : R,
                  C = i.section,
                  U = i.analyticsTags,
                  O = i.slCampaignOwner,
                  B = i.slCampaignId;
                return (
                  u && (o.name = u),
                  y && (o.customer_id = y),
                  k && (o.variation_id = k),
                  E && (o.result_id = E),
                  typeof g == 'boolean' && (o.item_is_convertible = g),
                  C && (o.section = C),
                  U && (o.analytics_tags = U),
                  B && (o.sl_campaign_id = B),
                  O && (o.sl_campaign_owner = O),
                  this.requests.queue(''.concat(s).concat(I(o, this.options)), void 0, void 0, n),
                  this.requests.send(),
                  !0
                );
              }
              return (this.requests.send(), new Error('parameters are required of type object'));
            }
            return (this.requests.send(), new Error('term is a required parameter of type string'));
          },
        },
        {
          key: 'trackConversion',
          value: function (e, i) {
            var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            if (i && (0, L.default)(i) === 'object' && !Array.isArray(i)) {
              var s = e || 'TERM_UNKNOWN',
                o = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/conversion?'),
                c = {},
                l = {},
                a = i.name,
                u = i.item_name,
                f = i.itemName,
                v = f === void 0 ? u || a : f,
                h = i.customer_id,
                _ = i.customerId,
                p = _ === void 0 ? h : _,
                y = i.item_id,
                m = i.itemId,
                w = m === void 0 ? y || p : m,
                k = i.variation_id,
                S = i.variationId,
                q = S === void 0 ? k : S,
                E = i.revenue,
                d = i.section,
                R = d === void 0 ? 'Products' : d,
                g = i.display_name,
                C = i.displayName,
                U = C === void 0 ? g : C,
                O = i.type,
                B = i.is_custom_type,
                M = i.isCustomType,
                P = M === void 0 ? B : M;
              (w && (l.item_id = w),
                v && (l.item_name = v),
                q && (l.variation_id = q),
                (E || E === 0) && (l.revenue = E.toString()),
                R && ((c.section = R), (l.section = R)),
                s && (l.search_term = s),
                O && (l.type = O),
                P && (l.is_custom_type = P),
                U && (l.display_name = U));
              var J = ''.concat(o).concat(I(c, this.options)),
                Q = 'POST',
                j = D(l, x(x({}, this.options), {}, { requestMethod: Q }));
              return (this.requests.queue(J, Q, j, n), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters are required of type object'));
          },
        },
        {
          key: 'trackPurchase',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/purchase?'),
                s = {},
                o = {},
                c = e.items,
                l = e.revenue,
                a = e.order_id,
                u = e.orderId,
                f = u === void 0 ? a : u,
                v = e.section,
                h = e.analyticsTags,
                _ = this.options.apiKey;
              if (f) {
                if (A.hasOrderIdRecord({ orderId: f, apiKey: _ })) return !1;
                (A.addOrderIdRecord({ orderId: f, apiKey: _ }), (o.order_id = f));
              }
              (c &&
                Array.isArray(c) &&
                (o.items = c.slice(0, 100).map(function (w) {
                  return A.toSnakeCaseKeys(w, !1);
                })),
                (l || l === 0) && (o.revenue = l),
                v ? (s.section = v) : (s.section = 'Products'),
                h && (o.analytics_tags = h));
              var p = ''.concat(n).concat(I(s, this.options)),
                y = 'POST',
                m = D(o, x(x({}, this.options), {}, { requestMethod: y }));
              return (this.requests.queue(p, y, m, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters are required of type object'));
          },
        },
        {
          key: 'trackRecommendationView',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/recommendation_result_view?'),
                s = {},
                o = e.result_count,
                c = e.result_page,
                l = e.resultPage,
                a = l === void 0 ? c : l,
                u = e.result_id,
                f = e.resultId,
                v = f === void 0 ? u : f,
                h = e.section,
                _ = e.url,
                p = e.pod_id,
                y = e.podId,
                m = y === void 0 ? p : y,
                w = e.num_results_viewed,
                k = e.numResultsViewed,
                S = k === void 0 ? w : k,
                q = e.items,
                E = e.analyticsTags,
                d = e.seedItemIds,
                R = e.resultCount,
                g = R === void 0 ? o || q?.length || 0 : R;
              (A.isNil(g) || (s.result_count = g),
                A.isNil(a) || (s.result_page = a),
                v && (s.result_id = v),
                h ? (s.section = h) : (s.section = 'Products'),
                _ && (s.url = A.truncateString(_, Oe)),
                m && (s.pod_id = m),
                A.isNil(S) || (s.num_results_viewed = S),
                q &&
                  Array.isArray(q) &&
                  (s.items = q.slice(0, 100).map(function (B) {
                    return A.toSnakeCaseKeys(B, !1);
                  })),
                E && (s.analytics_tags = E),
                typeof d == 'number'
                  ? (s.seed_item_ids = [String(d)])
                  : d != null && d.length && typeof d == 'string'
                    ? (s.seed_item_ids = [d])
                    : d != null && d.length && Array.isArray(d) && (s.seed_item_ids = d));
              var C = ''.concat(n).concat(I({}, this.options)),
                U = 'POST',
                O = D(s, x(x({}, this.options), {}, { requestMethod: U }));
              return (this.requests.queue(C, U, O, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters are required of type object'));
          },
        },
        {
          key: 'trackMediaImpressionView',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n = A.getBehaviorUrl(this.options.mediaServiceUrl),
                s = ''.concat(n.toString(), 'v2/ad_behavioral_action/display_ad_view?'),
                o = {},
                c = e.bannerAdId,
                l = e.placementId,
                a = e.analyticsTags;
              (A.isNil(c) || (o.banner_ad_id = c),
                A.isNil(l) || (o.placement_id = l),
                A.isNil(a) || (o.analytics_tags = a));
              var u = ''.concat(s).concat(I({}, this.options)),
                f = 'POST',
                v = D(o, x(x({}, this.options), {}, { requestMethod: f }));
              return (this.requests.queue(u, f, v, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters are required of type object'));
          },
        },
        {
          key: 'trackMediaImpressionClick',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n = A.getBehaviorUrl(this.options.mediaServiceUrl),
                s = ''.concat(n.toString(), 'v2/ad_behavioral_action/display_ad_click?'),
                o = {},
                c = e.bannerAdId,
                l = e.placementId,
                a = e.analyticsTags;
              (A.isNil(c) || (o.banner_ad_id = c),
                A.isNil(l) || (o.placement_id = l),
                A.isNil(a) || (o.analytics_tags = a));
              var u = ''.concat(s).concat(I({}, this.options)),
                f = 'POST',
                v = D(o, x(x({}, this.options), {}, { requestMethod: f }));
              return (this.requests.queue(u, f, v, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters are required of type object'));
          },
        },
        {
          key: 'trackRecommendationClick',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/recommendation_result_click?'),
                s = {},
                o = e.variation_id,
                c = e.variationId,
                l = c === void 0 ? o : c,
                a = e.section,
                u = a === void 0 ? 'Products' : a,
                f = e.result_id,
                v = e.resultId,
                h = v === void 0 ? f : v,
                _ = e.result_count,
                p = e.resultCount,
                y = p === void 0 ? _ : p,
                m = e.result_page,
                w = e.resultPage,
                k = w === void 0 ? m : w,
                S = e.result_position_on_page,
                q = e.resultPositionOnPage,
                E = q === void 0 ? S : q,
                d = e.num_results_per_page,
                R = e.numResultsPerPage,
                g = R === void 0 ? d : R,
                C = e.pod_id,
                U = e.podId,
                O = U === void 0 ? C : U,
                B = e.strategy_id,
                M = e.strategyId,
                P = M === void 0 ? B : M,
                J = e.item_id,
                Q = e.itemId,
                j = Q === void 0 ? J : Q,
                X = e.item_name,
                H = e.itemName,
                W = H === void 0 ? X : H,
                Y = e.analyticsTags,
                V = e.slCampaignId,
                re = e.slCampaignOwner,
                G = e.seedItemIds;
              (l && (s.variation_id = l),
                u && (s.section = u),
                h && (s.result_id = h),
                A.isNil(y) || (s.result_count = y),
                A.isNil(k) || (s.result_page = k),
                A.isNil(E) || (s.result_position_on_page = E),
                A.isNil(g) || (s.num_results_per_page = g),
                O && (s.pod_id = O),
                P && (s.strategy_id = P),
                j && (s.item_id = j),
                W && (s.item_name = W),
                Y && (s.analytics_tags = Y),
                V && (s.sl_campaign_id = V),
                re && (s.sl_campaign_owner = re),
                typeof G == 'number'
                  ? (s.seed_item_ids = [String(G)])
                  : G != null && G.length && typeof G == 'string'
                    ? (s.seed_item_ids = [G])
                    : G != null && G.length && Array.isArray(G) && (s.seed_item_ids = G));
              var ue = ''.concat(n).concat(I({}, this.options)),
                ne = 'POST',
                ae = D(s, x(x({}, this.options), {}, { requestMethod: ne }));
              return (this.requests.queue(ue, ne, ae, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters are required of type object'));
          },
        },
        {
          key: 'trackBrowseResultsLoaded',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n,
                s = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/browse_result_load?'),
                o = {},
                c = e.section,
                l = c === void 0 ? 'Products' : c,
                a = e.result_count,
                u = e.result_page,
                f = e.resultPage,
                v = f === void 0 ? u : f,
                h = e.result_id,
                _ = e.resultId,
                p = _ === void 0 ? h : _,
                y = e.selected_filters,
                m = e.selectedFilters,
                w = m === void 0 ? y : m,
                k = e.url,
                S = e.sort_order,
                q = e.sortOrder,
                E = q === void 0 ? S : q,
                d = e.sort_by,
                R = e.sortBy,
                g = R === void 0 ? d : R,
                C = e.filter_name,
                U = e.filterName,
                O = U === void 0 ? C : U,
                B = e.filter_value,
                M = e.filterValue,
                P = M === void 0 ? B : M,
                J = e.items,
                Q = e.analyticsTags,
                j = e.resultCount,
                X = j === void 0 ? ((n = a ?? J?.length) !== null && n !== void 0 ? n : 0) : j;
              (l && (o.section = l),
                A.isNil(X) || (o.result_count = X),
                A.isNil(v) || (o.result_page = v),
                p && (o.result_id = p),
                w && (o.selected_filters = w),
                k && (o.url = A.truncateString(k, Oe)),
                E && (o.sort_order = E),
                g && (o.sort_by = g),
                O && (o.filter_name = O),
                P && (o.filter_value = P),
                J &&
                  Array.isArray(J) &&
                  (o.items = J.slice(0, 100).map(function (V) {
                    return A.toSnakeCaseKeys(V, !1);
                  })),
                Q && (o.analytics_tags = Q));
              var H = ''.concat(s).concat(I({}, this.options)),
                W = 'POST',
                Y = D(o, x(x({}, this.options), {}, { requestMethod: W }));
              return (this.requests.queue(H, W, Y, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters are required of type object'));
          },
        },
        {
          key: 'trackBrowseResultClick',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/browse_result_click?'),
                s = {},
                o = e.section,
                c = o === void 0 ? 'Products' : o,
                l = e.variation_id,
                a = e.variationId,
                u = a === void 0 ? l : a,
                f = e.result_id,
                v = e.resultId,
                h = v === void 0 ? f : v,
                _ = e.result_count,
                p = e.resultCount,
                y = p === void 0 ? _ : p,
                m = e.result_page,
                w = e.resultPage,
                k = w === void 0 ? m : w,
                S = e.result_position_on_page,
                q = e.resultPositionOnPage,
                E = q === void 0 ? S : q,
                d = e.num_results_per_page,
                R = e.numResultsPerPage,
                g = R === void 0 ? d : R,
                C = e.selected_filters,
                U = e.selectedFilters,
                O = U === void 0 ? C : U,
                B = e.filter_name,
                M = e.filterName,
                P = M === void 0 ? B : M,
                J = e.filter_value,
                Q = e.filterValue,
                j = Q === void 0 ? J : Q,
                X = e.customer_id,
                H = e.customerId,
                W = H === void 0 ? X : H,
                Y = e.item_id,
                V = e.itemId,
                re = V === void 0 ? W || Y : V,
                G = e.item_name,
                ue = e.name,
                ne = e.itemName,
                ae = ne === void 0 ? G || ue : ne,
                Fe = e.analyticsTags,
                Me = e.slCampaignId,
                ke = e.slCampaignOwner;
              (c && (s.section = c),
                u && (s.variation_id = u),
                h && (s.result_id = h),
                A.isNil(y) || (s.result_count = y),
                A.isNil(k) || (s.result_page = k),
                A.isNil(E) || (s.result_position_on_page = E),
                A.isNil(g) || (s.num_results_per_page = g),
                O && (s.selected_filters = O),
                P && (s.filter_name = P),
                j && (s.filter_value = j),
                re && (s.item_id = re),
                ae && (s.item_name = ae),
                Fe && (s.analytics_tags = Fe),
                Me && (s.sl_campaign_id = Me),
                ke && (s.sl_campaign_owner = ke));
              var tt = ''.concat(n).concat(I({}, this.options)),
                _e = 'POST',
                Ji = D(s, x(x({}, this.options), {}, { requestMethod: _e }));
              return (this.requests.queue(tt, _e, Ji, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters are required of type object'));
          },
        },
        {
          key: 'trackBrowseRedirect',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/browse_redirect?'),
                s = {},
                o = e.searchTerm,
                c = e.userInput,
                l = e.section,
                a = l === void 0 ? 'Products' : l,
                u = e.selectedFilters,
                f = e.redirectToUrl,
                v = e.sortOrder,
                h = e.sortBy,
                _ = e.filterName,
                p = e.filterValue,
                y = e.analyticsTags;
              (o && (s.search_term = o),
                c && (s.user_input = c),
                f && (s.redirect_to_url = f),
                a && (s.section = a),
                u && (s.selected_filters = u),
                v && (s.sort_order = v),
                h && (s.sort_by = h),
                _ && (s.filter_name = _),
                p && (s.filter_value = p),
                y && (s.analytics_tags = y));
              var m = ''.concat(n).concat(I({}, this.options)),
                w = 'POST',
                k = D(s, x(x({}, this.options), {}, { requestMethod: w }));
              return (this.requests.queue(m, w, k, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters are required of type object'));
          },
        },
        {
          key: 'trackGenericResultClick',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if ((0, L.default)(e) === 'object') {
              var n = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/result_click?'),
                s = {},
                o = e.item_id,
                c = e.itemId,
                l = c === void 0 ? o : c,
                a = e.item_name,
                u = e.itemName,
                f = u === void 0 ? a : u,
                v = e.variation_id,
                h = e.variationId,
                _ = h === void 0 ? v : h,
                p = e.section,
                y = p === void 0 ? 'Products' : p,
                m = e.analyticsTags;
              if (l) {
                ((s.section = y),
                  (s.item_id = l),
                  f && (s.item_name = f),
                  _ && (s.variation_id = _),
                  m && (s.analytics_tags = m));
                var w = ''.concat(n).concat(I({}, this.options)),
                  k = 'POST',
                  S = D(s, x(x({}, this.options), {}, { requestMethod: k }));
                return (this.requests.queue(w, k, S, i), this.requests.send(), !0);
              }
            }
            return (this.requests.send(), new Error('A parameters object with an "itemId" property is required.'));
          },
        },
        {
          key: 'trackQuizResultsLoaded',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/quiz_result_load?'),
                s = e.quiz_id,
                o = e.quizId,
                c = o === void 0 ? s : o,
                l = e.quiz_version_id,
                a = e.quizVersionId,
                u = a === void 0 ? l : a,
                f = e.quiz_session_id,
                v = e.quizSessionId,
                h = v === void 0 ? f : v,
                _ = e.url,
                p = e.section,
                y = p === void 0 ? 'Products' : p,
                m = e.result_count,
                w = e.resultCount,
                k = w === void 0 ? m : w,
                S = e.result_id,
                q = e.resultId,
                E = q === void 0 ? S : q,
                d = e.result_page,
                R = e.resultPage,
                g = R === void 0 ? d : R,
                C = e.items,
                U = {},
                O = {};
              if (
                (C &&
                  Array.isArray(C) &&
                  (O.items = C.slice(0, 100).map(function (J) {
                    return A.toSnakeCaseKeys(J, !1);
                  })),
                typeof c != 'string')
              )
                return new Error('"quizId" is a required parameter of type string');
              if (typeof u != 'string') return new Error('"quizVersionId" is a required parameter of type string');
              if (typeof h != 'string') return new Error('"quizSessionId" is a required parameter of type string');
              if (typeof _ != 'string') return new Error('"url" is a required parameter of type string');
              if (
                ((O.quiz_id = c),
                (O.quiz_version_id = u),
                (O.quiz_session_id = h),
                (O.url = A.truncateString(_, Oe)),
                !A.isNil(y))
              ) {
                if (typeof y != 'string') return new Error('"section" must be a string');
                ((U.section = y), (O.section = y));
              }
              if (!A.isNil(k)) {
                if (typeof k != 'number') return new Error('"resultCount" must be a number');
                O.result_count = k;
              }
              if (!A.isNil(E)) {
                if (typeof E != 'string') return new Error('"resultId" must be a string');
                O.result_id = E;
              }
              if (!A.isNil(g)) {
                if (typeof g != 'number') return new Error('"resultPage" must be a number');
                O.result_page = g;
              }
              var B = ''.concat(n).concat(I(U, this.options)),
                M = 'POST',
                P = D(O, x(x({}, this.options), {}, { requestMethod: M }));
              return (this.requests.queue(B, M, P, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters are required of type object'));
          },
        },
        {
          key: 'trackQuizResultClick',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/quiz_result_click?'),
                s = e.quiz_id,
                o = e.quizId,
                c = o === void 0 ? s : o,
                l = e.quiz_version_id,
                a = e.quizVersionId,
                u = a === void 0 ? l : a,
                f = e.quiz_session_id,
                v = e.quizSessionId,
                h = v === void 0 ? f : v,
                _ = e.item_id,
                p = e.itemId,
                y = p === void 0 ? _ : p,
                m = e.item_name,
                w = e.itemName,
                k = w === void 0 ? m : w,
                S = e.result_count,
                q = e.resultCount,
                E = q === void 0 ? S : q,
                d = e.result_id,
                R = e.resultId,
                g = R === void 0 ? d : R,
                C = e.result_page,
                U = e.resultPage,
                O = U === void 0 ? C : U,
                B = e.num_results_per_page,
                M = e.numResultsPerPage,
                P = M === void 0 ? B : M,
                J = e.result_position_on_page,
                Q = e.resultPositionOnPage,
                j = Q === void 0 ? J : Q,
                X = e.section,
                H = X === void 0 ? 'Products' : X,
                W = e.variationId,
                Y = {},
                V = {};
              if (typeof c != 'string') return new Error('"quizId" is a required parameter of type string');
              if (typeof u != 'string') return new Error('"quizVersionId" is a required parameter of type string');
              if (typeof h != 'string') return new Error('"quizSessionId" is a required parameter of type string');
              if (typeof y != 'string' && typeof k != 'string')
                return new Error('"itemId" or "itemName" is a required parameter of type string');
              if (((V.quiz_id = c), (V.quiz_version_id = u), (V.quiz_session_id = h), !A.isNil(y))) {
                if (typeof y != 'string') return new Error('"itemId" must be a string');
                V.item_id = y;
              }
              if (!A.isNil(k)) {
                if (typeof k != 'string') return new Error('"itemName" must be a string');
                V.item_name = k;
              }
              if (!A.isNil(W)) {
                if (typeof W != 'string') return new Error('"variationId" must be a string');
                V.variation_id = W;
              }
              if (!A.isNil(H)) {
                if (typeof H != 'string') return new Error('"section" must be a string');
                Y.section = H;
              }
              if (!A.isNil(E)) {
                if (typeof E != 'number') return new Error('"resultCount" must be a number');
                V.result_count = E;
              }
              if (!A.isNil(g)) {
                if (typeof g != 'string') return new Error('"resultId" must be a string');
                V.result_id = g;
              }
              if (!A.isNil(O)) {
                if (typeof O != 'number') return new Error('"resultPage" must be a number');
                V.result_page = O;
              }
              if (!A.isNil(P)) {
                if (typeof P != 'number') return new Error('"numResultsPerPage" must be a number');
                V.num_results_per_page = P;
              }
              if (!A.isNil(j)) {
                if (typeof j != 'number') return new Error('"resultPositionOnPage" must be a number');
                V.result_position_on_page = j;
              }
              var re = ''.concat(n).concat(I(Y, this.options)),
                G = 'POST',
                ue = D(V, x(x({}, this.options), {}, { requestMethod: G }));
              return (this.requests.queue(re, G, ue, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters are required of type object'));
          },
        },
        {
          key: 'trackQuizConversion',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/quiz_conversion?'),
                s = e.quiz_id,
                o = e.quizId,
                c = o === void 0 ? s : o,
                l = e.quiz_version_id,
                a = e.quizVersionId,
                u = a === void 0 ? l : a,
                f = e.quiz_session_id,
                v = e.quizSessionId,
                h = v === void 0 ? f : v,
                _ = e.item_id,
                p = e.itemId,
                y = p === void 0 ? _ : p,
                m = e.item_name,
                w = e.itemName,
                k = w === void 0 ? m : w,
                S = e.variation_id,
                q = e.variationId,
                E = q === void 0 ? S : q,
                d = e.revenue,
                R = e.section,
                g = R === void 0 ? 'Products' : R,
                C = e.type,
                U = e.is_custom_type,
                O = e.isCustomType,
                B = O === void 0 ? U : O,
                M = e.display_name,
                P = e.displayName,
                J = P === void 0 ? M : P,
                Q = {},
                j = {};
              if (typeof c != 'string') return new Error('"quizId" is a required parameter of type string');
              if (typeof u != 'string') return new Error('"quizVersionId" is a required parameter of type string');
              if (typeof h != 'string') return new Error('"quizSessionId" is a required parameter of type string');
              if (typeof y != 'string' && typeof k != 'string')
                return new Error('"itemId" or "itemName" is a required parameter of type string');
              if (((j.quiz_id = c), (j.quiz_version_id = u), (j.quiz_session_id = h), !A.isNil(y))) {
                if (typeof y != 'string') return new Error('"itemId" must be a string');
                j.item_id = y;
              }
              if (!A.isNil(k)) {
                if (typeof k != 'string') return new Error('"itemName" must be a string');
                j.item_name = k;
              }
              if (!A.isNil(E)) {
                if (typeof E != 'string') return new Error('"variationId" must be a string');
                j.variation_id = E;
              }
              if (!A.isNil(d)) {
                if (typeof d != 'string') return new Error('"revenue" must be a string');
                j.revenue = d;
              }
              if (!A.isNil(g)) {
                if (typeof g != 'string') return new Error('"section" must be a string');
                j.section = g;
              }
              if (!A.isNil(C)) {
                if (typeof C != 'string') return new Error('"type" must be a string');
                j.type = C;
              }
              if (!A.isNil(B)) {
                if (typeof B != 'boolean') return new Error('"isCustomType" must be a boolean');
                j.is_custom_type = B;
              }
              if (!A.isNil(J)) {
                if (typeof J != 'string') return new Error('"displayName" must be a string');
                j.display_name = J;
              }
              var X = ''.concat(n).concat(I(Q, this.options)),
                H = 'POST',
                W = D(j, x(x({}, this.options), {}, { requestMethod: H }));
              return (this.requests.queue(X, H, W, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters are required of type object'));
          },
        },
        {
          key: 'trackAgentSubmit',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/assistant_submit?'),
                s = e.section,
                o = e.intent,
                c = { intent: o, section: s },
                l = ''.concat(n).concat(I({}, this.options)),
                a = 'POST',
                u = D(c, x(x({}, this.options), {}, { requestMethod: a }));
              return (this.requests.queue(l, a, u, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters are required of type object'));
          },
        },
        {
          key: 'trackAgentResultLoadStarted',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/assistant_result_load_start?'),
                s = e.section,
                o = e.intentResultId,
                c = e.intent,
                l = { intent_result_id: o, intent: c, section: s },
                a = ''.concat(n).concat(I({}, this.options)),
                u = 'POST',
                f = D(l, x(x({}, this.options), {}, { requestMethod: u }));
              return (this.requests.queue(a, u, f, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters are required of type object'));
          },
        },
        {
          key: 'trackAgentResultLoadFinished',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/assistant_result_load_finish?'),
                s = e.section,
                o = e.searchResultCount,
                c = e.intentResultId,
                l = e.intent,
                a = { intent_result_id: c, section: s, intent: l, search_result_count: o },
                u = ''.concat(n).concat(I({}, this.options)),
                f = 'POST',
                v = D(a, x(x({}, this.options), {}, { requestMethod: f }));
              return (this.requests.queue(u, f, v, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters are required of type object'));
          },
        },
        {
          key: 'trackAgentResultClick',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/assistant_search_result_click?'),
                s = e.section,
                o = s === void 0 ? 'Products' : s,
                c = e.variationId,
                l = e.intentResultId,
                a = e.searchResultId,
                u = e.itemId,
                f = e.itemName,
                v = e.intent,
                h = {
                  section: o,
                  variation_id: c,
                  intent_result_id: l,
                  search_result_id: a,
                  item_id: u,
                  item_name: f,
                  intent: v,
                },
                _ = ''.concat(n).concat(I({}, this.options)),
                p = 'POST',
                y = D(h, x(x({}, this.options), {}, { requestMethod: p }));
              return (this.requests.queue(_, p, y, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters are required of type object'));
          },
        },
        {
          key: 'trackAgentResultView',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/assistant_search_result_view?'),
                s = e.section,
                o = s === void 0 ? 'Products' : s,
                c = e.items,
                l = e.numResultsViewed,
                a = e.intentResultId,
                u = e.searchResultId,
                f = e.intent,
                v = {
                  section: o,
                  intent_result_id: a,
                  search_result_id: u,
                  num_results_viewed: l,
                  items:
                    c &&
                    Array.isArray(c) &&
                    c.slice(0, 100).map(function (y) {
                      return A.toSnakeCaseKeys(y, !1);
                    }),
                  intent: f,
                },
                h = ''.concat(n).concat(I({}, this.options)),
                _ = 'POST',
                p = D(v, x(x({}, this.options), {}, { requestMethod: _ }));
              return (this.requests.queue(h, _, p, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters are required of type object'));
          },
        },
        {
          key: 'trackAgentSearchSubmit',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/assistant_search_submit?'),
                s = e.section,
                o = e.intent,
                c = e.searchTerm,
                l = e.searchResultId,
                a = e.intentResultId,
                u = { intent: o, section: s, search_term: c, search_result_id: l, intent_result_id: a },
                f = ''.concat(n).concat(I({}, this.options)),
                v = 'POST',
                h = D(u, x(x({}, this.options), {}, { requestMethod: v }));
              return (this.requests.queue(f, v, h, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters is a required parameter of type object'));
          },
        },
        {
          key: 'trackAssistantSubmit',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return this.trackAgentSubmit(e, i);
          },
        },
        {
          key: 'trackAssistantResultLoadStarted',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return this.trackAgentResultLoadStarted(e, i);
          },
        },
        {
          key: 'trackAssistantResultLoadFinished',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return this.trackAgentResultLoadFinished(e, i);
          },
        },
        {
          key: 'trackAssistantResultClick',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return this.trackAgentResultClick(e, i);
          },
        },
        {
          key: 'trackAssistantResultView',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return this.trackAgentResultView(e, i);
          },
        },
        {
          key: 'trackAssistantSearchSubmit',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return this.trackAgentSearchSubmit(e, i);
          },
        },
        {
          key: 'trackProductInsightsAgentViews',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/product_insights_agent_views?'),
                s = e.section,
                o = e.questions,
                c = e.itemId,
                l = e.itemName,
                a = e.variationId,
                u = e.viewTimespans,
                f = {},
                v = { questions: o, item_id: c, item_name: l, variation_id: a, view_timespans: u };
              s && (f.section = s);
              var h = ''.concat(n).concat(I(f, this.options)),
                _ = 'POST',
                p = D(v, x(x({}, this.options), {}, { requestMethod: _ }));
              return (this.requests.queue(h, _, p, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters is a required parameter of type object'));
          },
        },
        {
          key: 'trackProductInsightsAgentView',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/product_insights_agent_view?'),
                s = e.section,
                o = e.questions,
                c = e.itemId,
                l = e.itemName,
                a = e.variationId,
                u = {},
                f = { questions: o, item_id: c, item_name: l, variation_id: a };
              s && (u.section = s);
              var v = ''.concat(n).concat(I(u, this.options)),
                h = 'POST',
                _ = D(f, x(x({}, this.options), {}, { requestMethod: h }));
              return (this.requests.queue(v, h, _, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters is a required parameter of type object'));
          },
        },
        {
          key: 'trackProductInsightsAgentOutOfView',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/product_insights_agent_out_of_view?'),
                s = e.section,
                o = e.itemId,
                c = e.itemName,
                l = e.variationId,
                a = {},
                u = { item_id: o, item_name: c, variation_id: l };
              s && (a.section = s);
              var f = ''.concat(n).concat(I(a, this.options)),
                v = 'POST',
                h = D(u, x(x({}, this.options), {}, { requestMethod: v }));
              return (this.requests.queue(f, v, h, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters is a required parameter of type object'));
          },
        },
        {
          key: 'trackProductInsightsAgentFocus',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/product_insights_agent_focus?'),
                s = e.section,
                o = e.itemId,
                c = e.itemName,
                l = e.variationId,
                a = {},
                u = { item_id: o, item_name: c, variation_id: l };
              s && (a.section = s);
              var f = ''.concat(n).concat(I(a, this.options)),
                v = 'POST',
                h = D(u, x(x({}, this.options), {}, { requestMethod: v }));
              return (this.requests.queue(f, v, h, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters is a required parameter of type object'));
          },
        },
        {
          key: 'trackProductInsightsAgentQuestionClick',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n = ''.concat(
                  this.options.serviceUrl,
                  '/v2/behavioral_action/product_insights_agent_question_click?',
                ),
                s = e.section,
                o = e.itemId,
                c = e.itemName,
                l = e.variationId,
                a = e.question,
                u = {},
                f = { item_id: o, item_name: c, variation_id: l, question: a };
              s && (u.section = s);
              var v = ''.concat(n).concat(I(u, this.options)),
                h = 'POST',
                _ = D(f, x(x({}, this.options), {}, { requestMethod: h }));
              return (this.requests.queue(v, h, _, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters is a required parameter of type object'));
          },
        },
        {
          key: 'trackProductInsightsAgentQuestionSubmit',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n = ''.concat(
                  this.options.serviceUrl,
                  '/v2/behavioral_action/product_insights_agent_question_submit?',
                ),
                s = e.section,
                o = e.itemId,
                c = e.itemName,
                l = e.variationId,
                a = e.question,
                u = {},
                f = { item_id: o, item_name: c, variation_id: l, question: a };
              s && (u.section = s);
              var v = ''.concat(n).concat(I(u, this.options)),
                h = 'POST',
                _ = D(f, x(x({}, this.options), {}, { requestMethod: h }));
              return (this.requests.queue(v, h, _, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters is a required parameter of type object'));
          },
        },
        {
          key: 'trackProductInsightsAgentAnswerView',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n = ''.concat(this.options.serviceUrl, '/v2/behavioral_action/product_insights_agent_answer_view?'),
                s = e.section,
                o = e.itemId,
                c = e.itemName,
                l = e.variationId,
                a = e.question,
                u = e.answerText,
                f = e.qnaResultId,
                v = {},
                h = { item_id: o, item_name: c, variation_id: l, question: a, answer_text: u, qna_result_id: f };
              s && (v.section = s);
              var _ = ''.concat(n).concat(I(v, this.options)),
                p = 'POST',
                y = D(h, x(x({}, this.options), {}, { requestMethod: p }));
              return (this.requests.queue(_, p, y, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters is a required parameter of type object'));
          },
        },
        {
          key: 'trackProductInsightsAgentAnswerFeedback',
          value: function (e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (e && (0, L.default)(e) === 'object' && !Array.isArray(e)) {
              var n = ''.concat(
                  this.options.serviceUrl,
                  '/v2/behavioral_action/product_insights_agent_answer_feedback?',
                ),
                s = e.section,
                o = e.itemId,
                c = e.itemName,
                l = e.variationId,
                a = e.feedbackLabel,
                u = e.qnaResultId,
                f = {},
                v = { item_id: o, item_name: c, variation_id: l, feedback_label: a, qna_result_id: u };
              s && (f.section = s);
              var h = ''.concat(n).concat(I(f, this.options)),
                _ = 'POST',
                p = D(v, x(x({}, this.options), {}, { requestMethod: _ }));
              return (this.requests.queue(h, _, p, i), this.requests.send(), !0);
            }
            return (this.requests.send(), new Error('parameters is a required parameter of type object'));
          },
        },
        {
          key: 'on',
          value: function (e, i) {
            return e !== 'success' && e !== 'error'
              ? new Error('messageType must be a string of value "success" or "error"')
              : !i || typeof i != 'function'
                ? new Error('callback is required and must be a function')
                : (this.eventemitter.on(e, i), !0);
          },
        },
      ]);
    })();
    gi.RequestQueue = hi;
    _i.exports = gi;
  });
  var yi = N((We) => {
    'use strict';
    b();
    Object.defineProperty(We, '__esModule', { value: !0 });
    We.default = void 0;
    var is = (We.default = '2.77.1');
  });
  var pt = N((os, xe) => {
    b();
    function cn(r, t) {
      (t == null || t > r.length) && (t = r.length);
      for (var e = 0, i = Array(t); e < t; e++) i[e] = r[e];
      return i;
    }
    ((xe.exports = cn), (xe.exports.__esModule = !0), (xe.exports.default = xe.exports));
  });
  var wi = N((us, Ue) => {
    b();
    var ln = pt();
    function fn(r) {
      if (Array.isArray(r)) return ln(r);
    }
    ((Ue.exports = fn), (Ue.exports.__esModule = !0), (Ue.exports.default = Ue.exports));
  });
  var ki = N((cs, Te) => {
    b();
    function vn(r) {
      if ((typeof Symbol < 'u' && r[Symbol.iterator] != null) || r['@@iterator'] != null) return Array.from(r);
    }
    ((Te.exports = vn), (Te.exports.__esModule = !0), (Te.exports.default = Te.exports));
  });
  var qi = N((fs, Ie) => {
    b();
    var bi = pt();
    function dn(r, t) {
      if (r) {
        if (typeof r == 'string') return bi(r, t);
        var e = {}.toString.call(r).slice(8, -1);
        return (
          e === 'Object' && r.constructor && (e = r.constructor.name),
          e === 'Map' || e === 'Set'
            ? Array.from(r)
            : e === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)
              ? bi(r, t)
              : void 0
        );
      }
    }
    ((Ie.exports = dn), (Ie.exports.__esModule = !0), (Ie.exports.default = Ie.exports));
  });
  var mi = N((ds, Ne) => {
    b();
    function hn() {
      throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    ((Ne.exports = hn), (Ne.exports.__esModule = !0), (Ne.exports.default = Ne.exports));
  });
  var Si = N((gs, Le) => {
    b();
    var gn = wi(),
      _n = ki(),
      pn = qi(),
      yn = mi();
    function wn(r) {
      return gn(r) || _n(r) || pn(r) || yn();
    }
    ((Le.exports = wn), (Le.exports.__esModule = !0), (Le.exports.default = Le.exports));
  });
  var Ai = N((ps, Ei) => {
    'use strict';
    b();
    var Ye = Z(),
      kn = Ye($()),
      bn = Ye(ee()),
      qn = Ye(Si()),
      mn = Ye(ve()),
      Sn = de(),
      ie = te();
    function Xe(r, t, e, i) {
      var n = e.apiKey,
        s = e.clientId,
        o = e.sessionId,
        c = e.segments,
        l = e.userId,
        a = e.version,
        u = e.quizzesServiceUrl,
        f = { c: a },
        v = '';
      if (
        ((f.key = n),
        (f.i = s),
        (f.s = o),
        c && c.length && (f.us = c),
        l && (f.ui = String(l)),
        !r || typeof r != 'string')
      )
        throw new Error('quizId is a required parameter of type string');
      if (
        i === 'results' &&
        ((0, mn.default)(t.answers) !== 'object' || !Array.isArray(t.answers) || t.answers.length === 0)
      )
        throw new Error('answers is a required parameter of type array');
      if (t) {
        var h = t.section,
          _ = t.answers,
          p = t.quizSessionId,
          y = t.quizVersionId,
          m = t.page,
          w = t.resultsPerPage,
          k = t.filters,
          S = t.fmtOptions,
          q = t.hiddenFields,
          E = t.skipTracking;
        (h && (f.section = h),
          y && (f.quiz_version_id = y),
          p && (f.quiz_session_id = p),
          _ &&
            _.length &&
            (v = '&'.concat(
              ie.stringify({
                a: _.map(function (R) {
                  return (0, qn.default)(R.map(encodeURIComponent)).join(',');
                }),
              }),
            )),
          ie.isNil(m) || (f.page = m),
          ie.isNil(w) || (f.num_results_per_page = w),
          k && (f.filters = k),
          S && (f.fmt_options = S),
          q && (f.fmt_options ? (f.fmt_options.hidden_fields = q) : (f.fmt_options = { hidden_fields: q })),
          E && (f.skip_tracking = E));
      }
      ((f._dt = Date.now()), (f = ie.cleanParams(f)));
      var d = ie.stringify(f);
      return ''
        .concat(u, '/v1/quizzes/')
        .concat(encodeURIComponent(r), '/')
        .concat(encodeURIComponent(i), '/?')
        .concat(d)
        .concat(v);
    }
    var En = (function () {
      function r(t) {
        ((0, kn.default)(this, r), (this.options = t || {}), (this.eventDispatcher = new Sn(t.eventDispatcher)));
      }
      return (0, bn.default)(r, [
        {
          key: 'getQuizNextQuestion',
          value: function (e, i) {
            var n = this,
              s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {},
              o,
              c = this.options.fetch,
              l = new AbortController(),
              a = l.signal;
            try {
              o = Xe(e, i, this.options, 'next');
            } catch (u) {
              return Promise.reject(u);
            }
            return (
              ie.applyNetworkTimeout(this.options, s, l),
              c(o, { signal: a })
                .then(ie.convertResponseToJson)
                .then(function (u) {
                  if (u.quiz_version_id)
                    return (n.eventDispatcher.queue('quizzes.getQuizNextQuestion.completed', u), u);
                  throw new Error('getQuizNextQuestion response data is malformed');
                })
            );
          },
        },
        {
          key: 'getQuizResults',
          value: function (e, i) {
            var n = this,
              s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {},
              o,
              c = this.options.fetch,
              l = new AbortController(),
              a = l.signal;
            try {
              o = Xe(e, i, this.options, 'results');
            } catch (u) {
              return Promise.reject(u);
            }
            return (
              ie.applyNetworkTimeout(this.options, s, l),
              c(o, { signal: a })
                .then(ie.convertResponseToJson)
                .then(function (u) {
                  if (u.quiz_version_id) return (n.eventDispatcher.queue('quizzes.getQuizResults.completed', u), u);
                  throw new Error('getQuizResults response data is malformed');
                })
            );
          },
        },
        {
          key: 'getQuizResultsConfig',
          value: function (e, i) {
            var n = this,
              s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {},
              o,
              c = this.options.fetch,
              l = new AbortController(),
              a = l.signal;
            try {
              o = Xe(e, i, this.options, 'results_config');
            } catch (u) {
              return Promise.reject(u);
            }
            return (
              ie.applyNetworkTimeout(this.options, s, l),
              c(o, { signal: a })
                .then(ie.convertResponseToJson)
                .then(function (u) {
                  if (u.quiz_version_id)
                    return (n.eventDispatcher.queue('quizzes.getQuizResultsConfig.completed', u), u);
                  throw new Error('getQuizResultsConfig response data is malformed');
                })
            );
          },
        },
        {
          key: 'getQuizAllQuestions',
          value: function (e, i) {
            var n = this,
              s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {},
              o,
              c = this.options.fetch,
              l = new AbortController(),
              a = l.signal;
            try {
              o = Xe(e, i, this.options, 'all_questions');
            } catch (u) {
              return Promise.reject(u);
            }
            return (
              ie.applyNetworkTimeout(this.options, s, l),
              c(o, { signal: a })
                .then(ie.convertResponseToJson)
                .then(function (u) {
                  if (u.quiz_version_id)
                    return (n.eventDispatcher.queue('quizzes.getQuizAllQuestions.completed', u), u);
                  throw new Error('getQuizAllQuestions response data is malformed');
                })
            );
          },
        },
      ]);
    })();
    Ei.exports = En;
  });
  var $e = N((ws, Ze) => {
    'use strict';
    b();
    var yt = Z(),
      An = yt($()),
      Rn = yt(ee()),
      Cn = yt(Re()),
      De = te(),
      On = De.cleanParams,
      xn = De.trimNonBreakingSpaces,
      Un = De.encodeURIComponentRFC3986,
      Tn = De.stringify,
      In = De.isNil;
    function Ri(r, t, e) {
      var i = e.apiKey,
        n = e.version,
        s = e.sessionId,
        o = e.clientId,
        c = e.userId,
        l = e.segments,
        a = e.testCells,
        u = e.agentServiceUrl,
        f = e.assistantServiceUrl,
        v = { c: n };
      ((v.key = i), (v.i = o), (v.s = s));
      var h = u || f;
      if (!r || typeof r != 'string') throw new Error('intent is a required parameter of type string');
      if (!t || !t.domain || typeof t.domain != 'string')
        throw new Error('parameters.domain is a required parameter of type string');
      if (
        (a &&
          Object.keys(a).forEach(function (g) {
            v['ef-'.concat(g)] = a[g];
          }),
        l && l.length && (v.us = l),
        c && (v.ui = String(c)),
        t)
      ) {
        var _ = t.domain,
          p = t.numResultsPerPage,
          y = t.threadId,
          m = t.guard,
          w = t.numResultsPerEvent,
          k = t.numResultEvents,
          S = t.qsParam,
          q = t.preFilterExpression,
          E = t.fmtOptions;
        (_ && (v.domain = _),
          p && (v.num_results_per_page = p),
          y && (v.thread_id = y),
          In(m) || (v.guard = m),
          w && (v.num_results_per_event = w),
          k && (v.num_result_events = k),
          S && (v.qs = JSON.stringify(S)),
          q && (v.pre_filter_expression = JSON.stringify(q)),
          E && (v.fmt_options = E));
      }
      ((v._dt = Date.now()), (v = On(v)));
      var d = Tn(v),
        R = r.replace(/^\//, '|');
      return ''
        .concat(h, '/v1/intent/')
        .concat(Un(xn(R)), '?')
        .concat(d);
    }
    function Ci(r, t, e) {
      var i = function (s) {
        r.addEventListener(s, function (o) {
          var c = JSON.parse(o.data);
          t.enqueue({ type: s, data: c });
        });
      };
      (Object.values(e).forEach(function (n) {
        n !== e.END && i(n);
      }),
        r.addEventListener(e.END, function () {
          (t.close(), r.close());
        }),
        (r.onerror = function (n) {
          (t.error(n), r.close());
        }));
    }
    var Oi = (function () {
      function r(t) {
        ((0, An.default)(this, r), (this.options = t || {}));
      }
      return (0, Rn.default)(r, [
        {
          key: 'getAgentResultsStream',
          value: function (e, i) {
            var n, s;
            try {
              var o = Ri(e, i, this.options);
              ((n = new EventSource(o)),
                (s = new ReadableStream({
                  start: function (u) {
                    Ci(n, u, r.EventTypes);
                  },
                  cancel: function () {
                    n.close();
                  },
                })));
            } catch (a) {
              if (s) {
                var c;
                (c = s) === null || c === void 0 || c.cancel();
              } else {
                var l;
                (l = n) === null || l === void 0 || l.close();
              }
              throw new Error(a.message);
            }
            return s;
          },
        },
      ]);
    })();
    (0, Cn.default)(Oi, 'EventTypes', {
      START: 'start',
      GROUP: 'group',
      SEARCH_RESULT: 'search_result',
      ARTICLE_REFERENCE: 'article_reference',
      RECIPE_INFO: 'recipe_info',
      RECIPE_INSTRUCTIONS: 'recipe_instructions',
      SERVER_ERROR: 'server_error',
      IMAGE_META: 'image_meta',
      MESSAGE: 'message',
      FOLLOW_UP_QUESTIONS: 'follow_up_questions',
      END: 'end',
    });
    Ze.exports = Oi;
    Ze.exports.createAgentUrl = Ri;
    Ze.exports.setupEventListeners = Ci;
  });
  var xi = N((bs, Be) => {
    b();
    function Nn(r) {
      if (r === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return r;
    }
    ((Be.exports = Nn), (Be.exports.__esModule = !0), (Be.exports.default = Be.exports));
  });
  var Ui = N((ms, je) => {
    b();
    var Ln = ve().default,
      Dn = xi();
    function Bn(r, t) {
      if (t && (Ln(t) == 'object' || typeof t == 'function')) return t;
      if (t !== void 0) throw new TypeError('Derived constructors may only return object or undefined');
      return Dn(r);
    }
    ((je.exports = Bn), (je.exports.__esModule = !0), (je.exports.default = je.exports));
  });
  var Ti = N((Es, le) => {
    b();
    function wt(r) {
      return (
        (le.exports = wt =
          Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (t) {
                return t.__proto__ || Object.getPrototypeOf(t);
              }),
        (le.exports.__esModule = !0),
        (le.exports.default = le.exports),
        wt(r)
      );
    }
    ((le.exports = wt), (le.exports.__esModule = !0), (le.exports.default = le.exports));
  });
  var Ii = N((Rs, fe) => {
    b();
    function kt(r, t) {
      return (
        (fe.exports = kt =
          Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (e, i) {
                return ((e.__proto__ = i), e);
              }),
        (fe.exports.__esModule = !0),
        (fe.exports.default = fe.exports),
        kt(r, t)
      );
    }
    ((fe.exports = kt), (fe.exports.__esModule = !0), (fe.exports.default = fe.exports));
  });
  var Ni = N((Os, Pe) => {
    b();
    var jn = Ii();
    function Pn(r, t) {
      if (typeof t != 'function' && t !== null)
        throw new TypeError('Super expression must either be null or a function');
      ((r.prototype = Object.create(t && t.prototype, { constructor: { value: r, writable: !0, configurable: !0 } })),
        Object.defineProperty(r, 'prototype', { writable: !1 }),
        t && jn(r, t));
    }
    ((Pe.exports = Pn), (Pe.exports.__esModule = !0), (Pe.exports.default = Pe.exports));
  });
  var Pi = N((Us, et) => {
    'use strict';
    b();
    var we = Z(),
      Fn = we($()),
      Mn = we(ee()),
      zn = we(Ui()),
      Li = we(Ti()),
      Jn = we(Ni()),
      Vn = we(Re());
    function Kn(r, t, e) {
      return (
        (t = (0, Li.default)(t)),
        (0, zn.default)(r, Bi() ? Reflect.construct(t, e || [], (0, Li.default)(r).constructor) : t.apply(r, e))
      );
    }
    function Bi() {
      try {
        var r = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      } catch {}
      return (Bi = function () {
        return !!r;
      })();
    }
    var Di = $e(),
      ji = $e(),
      Gn = ji.createAgentUrl,
      Hn = ji.setupEventListeners,
      Qn = (function (r) {
        function t() {
          var e;
          (0, Fn.default)(this, t);
          for (var i = arguments.length, n = new Array(i), s = 0; s < i; s++) n[s] = arguments[s];
          return ((e = Kn(this, t, [].concat(n))), (0, Vn.default)(e, 'EventTypes', Di.EventTypes), e);
        }
        return (
          (0, Jn.default)(t, r),
          (0, Mn.default)(t, [
            {
              key: 'getAssistantResultsStream',
              value: function (i, n) {
                return this.getAgentResultsStream(i, n);
              },
            },
          ])
        );
      })(Di);
    et.exports = Qn;
    et.exports.createAssistantUrl = Gn;
    et.exports.setupEventListeners = Hn;
  });
  var co = N((Is, zi) => {
    b();
    var Fi = Z(),
      Wn = Fi($()),
      Xn = Fi(ee()),
      Yn = At(),
      Zn = Bt(),
      $n = Ft(),
      eo = Jt(),
      to = Gt(),
      Mi = pi(),
      io = de(),
      ge = te(),
      ro = yi(),
      no = ro.default,
      oo = Ai(),
      so = $e(),
      uo = Pi(),
      ao = function () {
        var t = 'ciojs-client-',
          e = [];
        return (
          ge.canUseDOM() || e.push('domless'),
          typeof T < 'u' && typeof T.env < 'u' && T.env.BUNDLED && e.push('bundled'),
          ''
            .concat(t)
            .concat(e.join('-'))
            .concat(e.length ? '-' : '')
            .concat(no)
        );
      },
      bt = (function () {
        function r() {
          var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          (0, Wn.default)(this, r);
          var e = t.apiKey,
            i = t.version,
            n = t.serviceUrl,
            s = t.quizzesServiceUrl,
            o = t.agentServiceUrl,
            c = t.assistantServiceUrl,
            l = t.mediaServiceUrl,
            a = t.segments,
            u = t.testCells,
            f = t.clientId,
            v = t.sessionId,
            h = t.userId,
            _ = t.fetch,
            p = t.trackingSendDelay,
            y = t.sendReferrerWithTrackingEvents,
            m = t.sendTrackingEvents,
            w = t.eventDispatcher,
            k = t.idOptions,
            S = t.beaconMode,
            q = t.networkParameters,
            E = t.humanityCheckLocation;
          if (!e || typeof e != 'string') throw new Error('API key is a required parameter of type string');
          var d,
            R,
            g = typeof window < 'u' && window.CLIENT_VERSION;
          if (ge.canUseDOM()) {
            var C = new Yn(k || {});
            ((d = C.session_id), (R = C.client_id));
          } else {
            if (!v || typeof v != 'number') throw new Error('sessionId is a required user parameter of type number');
            if (!f || typeof f != 'string') throw new Error('clientId is a required user parameter of type string');
          }
          var U = n && n.replace(/\/$/, '');
          ((this.options = {
            apiKey: e,
            version: i || g || ao(),
            serviceUrl: ge.addHTTPSToString(U) || 'https://ac.cnstrc.com',
            quizzesServiceUrl: (s && s.replace(/\/$/, '')) || 'https://quizzes.cnstrc.com',
            agentServiceUrl: (o && o.replace(/\/$/, '')) || 'https://agent.cnstrc.com',
            assistantServiceUrl: (c && c.replace(/\/$/, '')) || 'https://assistant.cnstrc.com',
            mediaServiceUrl: (l && l.replace(/\/$/, '')) || 'https://media-cnstrc.com',
            sessionId: v || d,
            clientId: f || R,
            userId: h,
            segments: a,
            testCells: ge.toValidTestCells(u),
            fetch: _ || fetch,
            trackingSendDelay: p,
            sendTrackingEvents: m,
            sendReferrerWithTrackingEvents: y,
            eventDispatcher: w,
            beaconMode: S !== !1,
            networkParameters: q || {},
            humanityCheckLocation: E || 'session',
          }),
            (this.search = new Zn(this.options)),
            (this.browse = new $n(this.options)),
            (this.autocomplete = new eo(this.options)),
            (this.recommendations = new to(this.options)),
            (this.tracker = new Mi(this.options)),
            (this.quizzes = new oo(this.options)),
            (this.agent = new so(this.options)),
            (this.assistant = new uo(this.options)),
            new io(t.eventDispatcher).queue('instantiated', this.options));
        }
        return (0, Xn.default)(r, [
          {
            key: 'setClientOptions',
            value: function (e) {
              if (Object.keys(e).length) {
                var i = e.apiKey,
                  n = e.segments,
                  s = e.testCells,
                  o = e.sessionId,
                  c = e.userId,
                  l = e.sendTrackingEvents;
                (i && (this.options.apiKey = i),
                  n && (this.options.segments = n),
                  s && (this.options.testCells = ge.toValidTestCells(s)),
                  typeof l == 'boolean' &&
                    ((this.options.sendTrackingEvents = l), (this.tracker.requests.sendTrackingEvents = l)),
                  o && !ge.canUseDOM() && (this.options.sessionId = o),
                  'userId' in e && (this.options.userId = c));
              }
            },
          },
        ]);
      })();
    bt.Tracker = Mi;
    ge.canUseDOM() && (window.ConstructorioClient = bt);
    zi.exports = bt;
  });
  co();
})();
/*! Bundled license information:

crc-32/crc32.js:
  (*! crc32.js (C) 2014-present SheetJS -- http://sheetjs.com *)
*/
